// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../fonts/fonts.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../images/icons/close-icon.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,<svg fill=%27gray%27 height=%2724%27 viewBox=%270 0 24 24%27 width=%2724%27 xmlns=%27http://www.w3.org/2000/svg%27><path d=%27M7 10l5 5 5-5z%27/><path d=%27M0 0h24v24H0z%27 fill=%27none%27/></svg>", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../images/icons/modalclose.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* Tailwind CSS - Required for PromotionIQ module */
*, ::before, ::after{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
::backdrop{
    --tw-border-spacing-x: 0;
    --tw-border-spacing-y: 0;
    --tw-translate-x: 0;
    --tw-translate-y: 0;
    --tw-rotate: 0;
    --tw-skew-x: 0;
    --tw-skew-y: 0;
    --tw-scale-x: 1;
    --tw-scale-y: 1;
    --tw-pan-x:  ;
    --tw-pan-y:  ;
    --tw-pinch-zoom:  ;
    --tw-scroll-snap-strictness: proximity;
    --tw-gradient-from-position:  ;
    --tw-gradient-via-position:  ;
    --tw-gradient-to-position:  ;
    --tw-ordinal:  ;
    --tw-slashed-zero:  ;
    --tw-numeric-figure:  ;
    --tw-numeric-spacing:  ;
    --tw-numeric-fraction:  ;
    --tw-ring-inset:  ;
    --tw-ring-offset-width: 0px;
    --tw-ring-offset-color: #fff;
    --tw-ring-color: rgb(59 130 246 / 0.5);
    --tw-ring-offset-shadow: 0 0 #0000;
    --tw-ring-shadow: 0 0 #0000;
    --tw-shadow: 0 0 #0000;
    --tw-shadow-colored: 0 0 #0000;
    --tw-blur:  ;
    --tw-brightness:  ;
    --tw-contrast:  ;
    --tw-grayscale:  ;
    --tw-hue-rotate:  ;
    --tw-invert:  ;
    --tw-saturate:  ;
    --tw-sepia:  ;
    --tw-drop-shadow:  ;
    --tw-backdrop-blur:  ;
    --tw-backdrop-brightness:  ;
    --tw-backdrop-contrast:  ;
    --tw-backdrop-grayscale:  ;
    --tw-backdrop-hue-rotate:  ;
    --tw-backdrop-invert:  ;
    --tw-backdrop-opacity:  ;
    --tw-backdrop-saturate:  ;
    --tw-backdrop-sepia:  ;
    --tw-contain-size:  ;
    --tw-contain-layout:  ;
    --tw-contain-paint:  ;
    --tw-contain-style:  ;
}
.container{
    width: 100%;
    margin-right: auto;
    margin-left: auto;
    padding-right: 2rem;
    padding-left: 2rem;
}
@media (min-width: 1400px){
    .container{
        max-width: 1400px;
    }
}
/* Scoped styles for PromotionIQ wrapper */
.promotioniq-theme {
    /* Reset conflicting platform-ui styles within PromotionIQ */
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    
    /* Ensure full height for PromotionIQ layout */
    min-height: 100vh;
    background-color: hsl(var(--background));
    color: hsl(var(--foreground));
  }
/* Tailwind Preflight (CSS Reset) - Scoped to PromotionIQ */
/* This enables Tailwind utilities to work correctly within PromotionIQ */
.promotioniq-theme *,
  .promotioniq-theme *::before,
  .promotioniq-theme *::after {
    box-sizing: border-box;
    border-width: 0;
    border-style: solid;
    border-color: hsl(var(--border));
  }
.promotioniq-theme {
    line-height: 1.5;
    -webkit-text-size-adjust: 100%;
    tab-size: 4;
  }
.promotioniq-theme hr {
    height: 0;
    color: inherit;
    border-top-width: 1px;
  }
.promotioniq-theme abbr:where([title]) {
    text-decoration: underline dotted;
  }
.promotioniq-theme b,
  .promotioniq-theme strong {
    font-weight: bolder;
  }
.promotioniq-theme code,
  .promotioniq-theme kbd,
  .promotioniq-theme samp,
  .promotioniq-theme pre {
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
    font-size: 1em;
  }
.promotioniq-theme small {
    font-size: 80%;
  }
.promotioniq-theme sub,
  .promotioniq-theme sup {
    font-size: 75%;
    line-height: 0;
    position: relative;
    vertical-align: baseline;
  }
.promotioniq-theme sub {
    bottom: -0.25em;
  }
.promotioniq-theme sup {
    top: -0.5em;
  }
.promotioniq-theme table {
    text-indent: 0;
    border-color: inherit;
    border-collapse: collapse;
  }
.promotioniq-theme button,
  .promotioniq-theme input,
  .promotioniq-theme optgroup,
  .promotioniq-theme select,
  .promotioniq-theme textarea {
    font-family: inherit;
    font-feature-settings: inherit;
    font-variation-settings: inherit;
    font-size: 100%;
    font-weight: inherit;
    line-height: inherit;
    color: inherit;
    margin: 0;
    padding: 0;
  }
.promotioniq-theme button,
  .promotioniq-theme select {
    text-transform: none;
  }
.promotioniq-theme button,
  .promotioniq-theme [type='button'],
  .promotioniq-theme [type='reset'],
  .promotioniq-theme [type='submit'] {
    -webkit-appearance: button;
    background-color: transparent;
    background-image: none;
  }
.promotioniq-theme :-moz-focusring {
    outline: auto;
  }
.promotioniq-theme :-moz-ui-invalid {
    box-shadow: none;
  }
.promotioniq-theme progress {
    vertical-align: baseline;
  }
.promotioniq-theme ::-webkit-inner-spin-button,
  .promotioniq-theme ::-webkit-outer-spin-button {
    height: auto;
  }
.promotioniq-theme [type='search'] {
    -webkit-appearance: textfield;
    outline-offset: -2px;
  }
.promotioniq-theme ::-webkit-search-decoration {
    -webkit-appearance: none;
  }
.promotioniq-theme ::-webkit-file-upload-button {
    -webkit-appearance: button;
    font: inherit;
  }
.promotioniq-theme summary {
    display: list-item;
  }
.promotioniq-theme blockquote,
  .promotioniq-theme dl,
  .promotioniq-theme dd,
  .promotioniq-theme figure,
  .promotioniq-theme h1,
  .promotioniq-theme h2,
  .promotioniq-theme h3,
  .promotioniq-theme h4,
  .promotioniq-theme h5,
  .promotioniq-theme h6,
  .promotioniq-theme hr,
  .promotioniq-theme p,
  .promotioniq-theme pre {
    margin: 0;
  }
.promotioniq-theme fieldset {
    margin: 0;
    padding: 0;
  }
.promotioniq-theme legend {
    padding: 0;
  }
.promotioniq-theme ol,
  .promotioniq-theme ul,
  .promotioniq-theme menu {
    list-style: none;
    margin: 0;
    padding: 0;
  }
.promotioniq-theme dialog {
    padding: 0;
  }
.promotioniq-theme textarea {
    resize: vertical;
  }
.promotioniq-theme input::placeholder,
  .promotioniq-theme textarea::placeholder {
    opacity: 1;
    color: hsl(var(--muted-foreground));
  }
.promotioniq-theme button,
  .promotioniq-theme [role="button"] {
    cursor: pointer;
  }
.promotioniq-theme :disabled {
    cursor: default;
  }
.promotioniq-theme img,
  .promotioniq-theme svg,
  .promotioniq-theme video,
  .promotioniq-theme canvas,
  .promotioniq-theme audio,
  .promotioniq-theme iframe,
  .promotioniq-theme embed,
  .promotioniq-theme object {
    display: block;
    vertical-align: middle;
  }
.promotioniq-theme img,
  .promotioniq-theme video {
    max-width: 100%;
    height: auto;
  }
.promotioniq-theme [hidden] {
    display: none;
  }
.promotioniq-theme h1,
  .promotioniq-theme h2,
  .promotioniq-theme h3,
  .promotioniq-theme h4,
  .promotioniq-theme h5,
  .promotioniq-theme h6 {
    font-family: 'Inter', system-ui, -apple-system, sans-serif;
    font-weight: 600;
    letter-spacing: -0.025em;
    color: inherit;
  }
.promotioniq-theme a {
    color: inherit;
    text-decoration: none;
  }
.promotioniq-theme button {
    font-family: inherit;
  }
/* Athena data table styling */
.promotioniq-theme .athena-table {
    width: 100%;
    border-collapse: collapse;
  }
.promotioniq-theme .athena-table thead {
    border-bottom: 1px solid hsl(var(--primary) / 0.3);
  }
.promotioniq-theme .athena-table th {
    padding: 0.75rem 1rem;
    text-align: left;
    font-size: 0.875rem;
    font-weight: 500;
    color: hsl(var(--primary));
  }
.promotioniq-theme .athena-table tbody tr {
    border-bottom: 1px solid hsl(var(--border) / 0.5);
    transition: background-color 0.15s;
  }
.promotioniq-theme .athena-table tbody tr:hover {
    background-color: hsl(var(--muted) / 0.3);
  }
.promotioniq-theme .athena-table tbody tr:nth-child(even) {
    background-color: hsl(var(--card) / 0.5);
  }
.promotioniq-theme .athena-table td {
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    color: hsl(var(--foreground));
  }
/* Metric cards */
.promotioniq-theme .metric-card {
    border: 1px solid hsl(var(--border));
    background-color: hsl(var(--card));
    padding: 1.5rem;
    transition: border-color 0.15s;
  }
.promotioniq-theme .metric-card:hover {
    border-color: hsl(var(--primary) / 0.5);
  }
.promotioniq-theme .metric-value {
    font-size: 1.875rem;
    font-weight: 700;
    color: hsl(var(--primary));
  }
.promotioniq-theme .metric-label {
    font-size: 0.875rem;
    color: hsl(var(--muted-foreground));
  }
/* Status badges */
.promotioniq-theme .status-badge {
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.75rem;
    font-size: 0.75rem;
    font-weight: 500;
  }
.promotioniq-theme .status-low {
    background-color: hsl(var(--success) / 0.2);
    color: hsl(var(--success));
  }
.promotioniq-theme .status-medium {
    background-color: hsl(var(--warning) / 0.2);
    color: hsl(var(--warning));
  }
.promotioniq-theme .status-high {
    background-color: hsl(var(--destructive) / 0.2);
    color: hsl(var(--destructive));
  }
/* Orange outlined button style */
.promotioniq-theme .btn-athena {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border: 2px solid hsl(var(--primary));
    background-color: transparent;
    padding: 0.5rem 1.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: hsl(var(--primary));
    transition: all 0.15s;
  }
.promotioniq-theme .btn-athena:hover {
    background-color: hsl(var(--primary));
    color: hsl(var(--primary-foreground));
  }
.promotioniq-theme .btn-athena-filled {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: hsl(var(--primary));
    padding: 0.5rem 1.5rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: hsl(var(--primary-foreground));
    transition: all 0.15s;
  }
.promotioniq-theme .btn-athena-filled:hover {
    background-color: hsl(var(--primary) / 0.9);
  }
/* Form inputs Athena style */
.promotioniq-theme .input-athena {
    width: 100%;
    border: 1px solid hsl(var(--border));
    background-color: hsl(var(--input));
    padding: 0.5rem 1rem;
    color: hsl(var(--foreground));
  }
.promotioniq-theme .input-athena::placeholder {
    color: hsl(var(--muted-foreground));
  }
.promotioniq-theme .input-athena:focus {
    border-color: hsl(var(--primary));
    outline: none;
    box-shadow: 0 0 0 1px hsl(var(--primary));
  }
.promotioniq-theme .label-athena {
    font-size: 0.875rem;
    font-weight: 500;
    color: hsl(var(--primary));
  }
/* Navigation tabs */
.promotioniq-theme .nav-tab {
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.75rem 1rem;
    font-size: 0.875rem;
    font-weight: 500;
    color: hsl(var(--muted-foreground));
    transition: color 0.15s;
  }
.promotioniq-theme .nav-tab:hover {
    color: hsl(var(--foreground));
  }
.promotioniq-theme .nav-tab.active {
    color: hsl(var(--primary));
  }
.promotioniq-theme .nav-tab.\\!active {
    color: hsl(var(--primary)) !important;
  }
.promotioniq-theme .nav-tab.active::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background-color: hsl(var(--primary));
  }
.promotioniq-theme .nav-tab.\\!active::after {
    content: '' !important;
    position: absolute !important;
    bottom: 0 !important;
    left: 0 !important;
    right: 0 !important;
    height: 2px !important;
    background-color: hsl(var(--primary)) !important;
  }
/* Section headers */
.promotioniq-theme .section-header {
    font-size: 1.125rem;
    font-weight: 600;
    color: hsl(var(--primary));
  }
/* Legend items */
.promotioniq-theme .legend-item {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    font-size: 0.875rem;
    color: hsl(var(--foreground));
  }
.promotioniq-theme .legend-dot {
    width: 0.75rem;
    height: 0.75rem;
  }
.sr-only{
    position: absolute !important;
    width: 1px !important;
    height: 1px !important;
    padding: 0 !important;
    margin: -1px !important;
    overflow: hidden !important;
    clip: rect(0, 0, 0, 0) !important;
    white-space: nowrap !important;
    border-width: 0 !important;
}
.pointer-events-none{
    pointer-events: none !important;
}
.pointer-events-auto{
    pointer-events: auto !important;
}
.visible{
    visibility: visible !important;
}
.invisible{
    visibility: hidden !important;
}
.static{
    position: static !important;
}
.fixed{
    position: fixed !important;
}
.absolute{
    position: absolute !important;
}
.relative{
    position: relative !important;
}
.sticky{
    position: sticky !important;
}
.inset-0{
    inset: 0px !important;
}
.inset-x-0{
    left: 0px !important;
    right: 0px !important;
}
.inset-y-0{
    top: 0px !important;
    bottom: 0px !important;
}
.-bottom-12{
    bottom: -3rem !important;
}
.-left-12{
    left: -3rem !important;
}
.-right-12{
    right: -3rem !important;
}
.-right-2{
    right: -0.5rem !important;
}
.-top-12{
    top: -3rem !important;
}
.bottom-0{
    bottom: 0px !important;
}
.bottom-3{
    bottom: 0.75rem !important;
}
.left-0{
    left: 0px !important;
}
.left-1{
    left: 0.25rem !important;
}
.left-1\\/2{
    left: 50% !important;
}
.left-2{
    left: 0.5rem !important;
}
.left-\\[50\\%\\]{
    left: 50% !important;
}
.right-0{
    right: 0px !important;
}
.right-1{
    right: 0.25rem !important;
}
.right-2{
    right: 0.5rem !important;
}
.right-3{
    right: 0.75rem !important;
}
.right-4{
    right: 1rem !important;
}
.top-0{
    top: 0px !important;
}
.top-1\\/2{
    top: 50% !important;
}
.top-2{
    top: 0.5rem !important;
}
.top-4{
    top: 1rem !important;
}
.top-6{
    top: 1.5rem !important;
}
.top-\\[110px\\]{
    top: 110px !important;
}
.top-\\[1px\\]{
    top: 1px !important;
}
.top-\\[50\\%\\]{
    top: 50% !important;
}
.top-\\[60\\%\\]{
    top: 60% !important;
}
.top-full{
    top: 100% !important;
}
.z-10{
    z-index: 10 !important;
}
.z-40{
    z-index: 40 !important;
}
.z-50{
    z-index: 50 !important;
}
.z-\\[100\\]{
    z-index: 100 !important;
}
.z-\\[1\\]{
    z-index: 1 !important;
}
.col-span-2{
    grid-column: span 2 / span 2 !important;
}
.float-end{
    float: inline-end !important;
}
.-m-1{
    margin: -0.25rem !important;
}
.-m-2{
    margin: -0.5rem !important;
}
.-mx-1{
    margin-left: -0.25rem !important;
    margin-right: -0.25rem !important;
}
.mx-1{
    margin-left: 0.25rem !important;
    margin-right: 0.25rem !important;
}
.mx-1\\.5{
    margin-left: 0.375rem !important;
    margin-right: 0.375rem !important;
}
.mx-5{
    margin-left: 1.25rem !important;
    margin-right: 1.25rem !important;
}
.mx-auto{
    margin-left: auto !important;
    margin-right: auto !important;
}
.my-0\\.5{
    margin-top: 0.125rem !important;
    margin-bottom: 0.125rem !important;
}
.my-1{
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important;
}
.-ml-4{
    margin-left: -1rem !important;
}
.-mt-4{
    margin-top: -1rem !important;
}
.mb-0{
    margin-bottom: 0px !important;
}
.mb-1{
    margin-bottom: 0.25rem !important;
}
.mb-2{
    margin-bottom: 0.5rem !important;
}
.mb-3{
    margin-bottom: 0.75rem !important;
}
.mb-4{
    margin-bottom: 1rem !important;
}
.mb-5{
    margin-bottom: 1.25rem !important;
}
.mb-6{
    margin-bottom: 1.5rem !important;
}
.me-2{
    margin-inline-end: 0.5rem !important;
}
.me-4{
    margin-inline-end: 1rem !important;
}
.ml-0\\.5{
    margin-left: 0.125rem !important;
}
.ml-1{
    margin-left: 0.25rem !important;
}
.ml-auto{
    margin-left: auto !important;
}
.mr-2{
    margin-right: 0.5rem !important;
}
.ms-0{
    margin-inline-start: 0px !important;
}
.ms-2{
    margin-inline-start: 0.5rem !important;
}
.ms-3{
    margin-inline-start: 0.75rem !important;
}
.ms-4{
    margin-inline-start: 1rem !important;
}
.mt-0{
    margin-top: 0px !important;
}
.mt-0\\.5{
    margin-top: 0.125rem !important;
}
.mt-1{
    margin-top: 0.25rem !important;
}
.mt-1\\.5{
    margin-top: 0.375rem !important;
}
.mt-2{
    margin-top: 0.5rem !important;
}
.mt-24{
    margin-top: 6rem !important;
}
.mt-3{
    margin-top: 0.75rem !important;
}
.mt-4{
    margin-top: 1rem !important;
}
.mt-5{
    margin-top: 1.25rem !important;
}
.mt-6{
    margin-top: 1.5rem !important;
}
.mt-auto{
    margin-top: auto !important;
}
.line-clamp-1{
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
}
.block{
    display: block !important;
}
.inline{
    display: inline !important;
}
.flex{
    display: flex !important;
}
.inline-flex{
    display: inline-flex !important;
}
.table{
    display: table !important;
}
.grid{
    display: grid !important;
}
.contents{
    display: contents !important;
}
.hidden{
    display: none !important;
}
.aspect-square{
    aspect-ratio: 1 / 1 !important;
}
.aspect-video{
    aspect-ratio: 16 / 9 !important;
}
.h-1\\.5{
    height: 0.375rem !important;
}
.h-10{
    height: 2.5rem !important;
}
.h-11{
    height: 2.75rem !important;
}
.h-12{
    height: 3rem !important;
}
.h-2{
    height: 0.5rem !important;
}
.h-2\\.5{
    height: 0.625rem !important;
}
.h-3{
    height: 0.75rem !important;
}
.h-3\\.5{
    height: 0.875rem !important;
}
.h-4{
    height: 1rem !important;
}
.h-5{
    height: 1.25rem !important;
}
.h-6{
    height: 1.5rem !important;
}
.h-7{
    height: 1.75rem !important;
}
.h-8{
    height: 2rem !important;
}
.h-9{
    height: 2.25rem !important;
}
.h-\\[150px\\]{
    height: 150px !important;
}
.h-\\[180px\\]{
    height: 180px !important;
}
.h-\\[1px\\]{
    height: 1px !important;
}
.h-\\[200px\\]{
    height: 200px !important;
}
.h-\\[250px\\]{
    height: 250px !important;
}
.h-\\[280px\\]{
    height: 280px !important;
}
.h-\\[300px\\]{
    height: 300px !important;
}
.h-\\[320px\\]{
    height: 320px !important;
}
.h-\\[350px\\]{
    height: 350px !important;
}
.h-\\[38px\\]{
    height: 38px !important;
}
.h-\\[80px\\]{
    height: 80px !important;
}
.h-\\[88px\\]{
    height: 88px !important;
}
.h-\\[var\\(--radix-navigation-menu-viewport-height\\)\\]{
    height: var(--radix-navigation-menu-viewport-height) !important;
}
.h-\\[var\\(--radix-select-trigger-height\\)\\]{
    height: var(--radix-select-trigger-height) !important;
}
.h-auto{
    height: auto !important;
}
.h-full{
    height: 100% !important;
}
.h-px{
    height: 1px !important;
}
.max-h-96{
    max-height: 24rem !important;
}
.max-h-\\[300px\\]{
    max-height: 300px !important;
}
.max-h-screen{
    max-height: 100vh !important;
}
.min-h-\\[400px\\]{
    min-height: 400px !important;
}
.min-h-\\[80px\\]{
    min-height: 80px !important;
}
.min-h-screen{
    min-height: 100vh !important;
}
.w-0{
    width: 0px !important;
}
.w-1{
    width: 0.25rem !important;
}
.w-1\\.5{
    width: 0.375rem !important;
}
.w-10{
    width: 2.5rem !important;
}
.w-11{
    width: 2.75rem !important;
}
.w-16{
    width: 4rem !important;
}
.w-2{
    width: 0.5rem !important;
}
.w-2\\.5{
    width: 0.625rem !important;
}
.w-20{
    width: 5rem !important;
}
.w-24{
    width: 6rem !important;
}
.w-3{
    width: 0.75rem !important;
}
.w-3\\.5{
    width: 0.875rem !important;
}
.w-3\\/4{
    width: 75% !important;
}
.w-4{
    width: 1rem !important;
}
.w-5{
    width: 1.25rem !important;
}
.w-6{
    width: 1.5rem !important;
}
.w-64{
    width: 16rem !important;
}
.w-7{
    width: 1.75rem !important;
}
.w-72{
    width: 18rem !important;
}
.w-8{
    width: 2rem !important;
}
.w-9{
    width: 2.25rem !important;
}
.w-\\[100px\\]{
    width: 100px !important;
}
.w-\\[150px\\]{
    width: 150px !important;
}
.w-\\[1px\\]{
    width: 1px !important;
}
.w-\\[200px\\]{
    width: 200px !important;
}
.w-fit{
    width: fit-content !important;
}
.w-full{
    width: 100% !important;
}
.w-max{
    width: max-content !important;
}
.w-px{
    width: 1px !important;
}
.min-w-0{
    min-width: 0px !important;
}
.min-w-\\[100px\\]{
    min-width: 100px !important;
}
.min-w-\\[12rem\\]{
    min-width: 12rem !important;
}
.min-w-\\[8rem\\]{
    min-width: 8rem !important;
}
.min-w-\\[var\\(--radix-select-trigger-width\\)\\]{
    min-width: var(--radix-select-trigger-width) !important;
}
.min-w-max{
    min-width: max-content !important;
}
.max-w-7xl{
    max-width: 80rem !important;
}
.max-w-lg{
    max-width: 32rem !important;
}
.max-w-max{
    max-width: max-content !important;
}
.max-w-md{
    max-width: 28rem !important;
}
.flex-1{
    flex: 1 1 !important;
}
.shrink-0{
    flex-shrink: 0 !important;
}
.flex-grow{
    flex-grow: 1 !important;
}
.grow{
    flex-grow: 1 !important;
}
.grow-0{
    flex-grow: 0 !important;
}
.basis-full{
    flex-basis: 100% !important;
}
.caption-bottom{
    caption-side: bottom !important;
}
.border-collapse{
    border-collapse: collapse !important;
}
.-translate-x-1\\/2{
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.-translate-y-1\\/2{
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-x-\\[-50\\%\\]{
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.translate-y-\\[-50\\%\\]{
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-45{
    --tw-rotate: 45deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.rotate-90{
    --tw-rotate: 90deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.transform{
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes fade-in{
    from{
        opacity: 0;
    }
    to{
        opacity: 1;
    }
}
.animate-fade-in{
    animation: fade-in 200ms ease-out !important;
}
@keyframes pulse{
    50%{
        opacity: .5;
    }
}
.animate-pulse{
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite !important;
}
.cursor-default{
    cursor: default !important;
}
.cursor-not-allowed{
    cursor: not-allowed !important;
}
.cursor-pointer{
    cursor: pointer !important;
}
.touch-none{
    touch-action: none !important;
}
.select-none{
    -webkit-user-select: none !important;
            user-select: none !important;
}
.select-all{
    -webkit-user-select: all !important;
            user-select: all !important;
}
.list-none{
    list-style-type: none !important;
}
.grid-cols-1{
    grid-template-columns: repeat(1, minmax(0, 1fr)) !important;
}
.grid-cols-12{
    grid-template-columns: repeat(12, minmax(0, 1fr)) !important;
}
.grid-cols-2{
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
}
.grid-cols-3{
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
}
.grid-cols-4{
    grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}
.flex-row{
    flex-direction: row !important;
}
.flex-col{
    flex-direction: column !important;
}
.flex-col-reverse{
    flex-direction: column-reverse !important;
}
.flex-wrap{
    flex-wrap: wrap !important;
}
.items-start{
    align-items: flex-start !important;
}
.items-end{
    align-items: flex-end !important;
}
.items-center{
    align-items: center !important;
}
.items-stretch{
    align-items: stretch !important;
}
.justify-start{
    justify-content: flex-start !important;
}
.justify-center{
    justify-content: center !important;
}
.justify-between{
    justify-content: space-between !important;
}
.gap-0{
    gap: 0px !important;
}
.gap-0\\.5{
    gap: 0.125rem !important;
}
.gap-1{
    gap: 0.25rem !important;
}
.gap-1\\.5{
    gap: 0.375rem !important;
}
.gap-2{
    gap: 0.5rem !important;
}
.gap-3{
    gap: 0.75rem !important;
}
.gap-4{
    gap: 1rem !important;
}
.gap-5{
    gap: 1.25rem !important;
}
.gap-6{
    gap: 1.5rem !important;
}
.space-x-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(0.25rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(0.25rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-x-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-x-reverse: 0 !important;
    margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.25rem * var(--tw-space-y-reverse)) !important;
}
.space-y-1\\.5 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.375rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.375rem * var(--tw-space-y-reverse)) !important;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.5rem * var(--tw-space-y-reverse)) !important;
}
.space-y-3 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(0.75rem * var(--tw-space-y-reverse)) !important;
}
.space-y-4 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1rem * var(--tw-space-y-reverse)) !important;
}
.space-y-6 > :not([hidden]) ~ :not([hidden]){
    --tw-space-y-reverse: 0 !important;
    margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse))) !important;
    margin-bottom: calc(1.5rem * var(--tw-space-y-reverse)) !important;
}
.overflow-auto{
    overflow: auto !important;
}
.overflow-hidden{
    overflow: hidden !important;
}
.overflow-x-auto{
    overflow-x: auto !important;
}
.overflow-y-auto{
    overflow-y: auto !important;
}
.overflow-x-hidden{
    overflow-x: hidden !important;
}
.whitespace-nowrap{
    white-space: nowrap !important;
}
.break-words{
    overflow-wrap: break-word !important;
}
.rounded{
    border-radius: 0.25rem !important;
}
.rounded-\\[2px\\]{
    border-radius: 2px !important;
}
.rounded-\\[inherit\\]{
    border-radius: inherit !important;
}
.rounded-full{
    border-radius: 9999px !important;
}
.rounded-lg{
    border-radius: 0px !important;
}
.rounded-md{
    border-radius: 0px !important;
}
.rounded-none{
    border-radius: 0px !important;
}
.rounded-sm{
    border-radius: 0px !important;
}
.rounded-t-\\[10px\\]{
    border-top-left-radius: 10px !important;
    border-top-right-radius: 10px !important;
}
.rounded-tl-sm{
    border-top-left-radius: 0px !important;
}
.border{
    border-width: 1px !important;
}
.border-0{
    border-width: 0px !important;
}
.border-2{
    border-width: 2px !important;
}
.border-\\[1\\.5px\\]{
    border-width: 1.5px !important;
}
.border-y{
    border-top-width: 1px !important;
    border-bottom-width: 1px !important;
}
.border-b{
    border-bottom-width: 1px !important;
}
.border-l{
    border-left-width: 1px !important;
}
.border-r{
    border-right-width: 1px !important;
}
.border-t{
    border-top-width: 1px !important;
}
.border-dashed{
    border-style: dashed !important;
}
.border-\\[--color-border\\]{
    border-color: var(--color-border) !important;
}
.border-border{
    border-color: hsl(var(--border)) !important;
}
.border-border\\/50{
    border-color: hsl(var(--border) / 0.5) !important;
}
.border-destructive{
    border-color: hsl(var(--destructive)) !important;
}
.border-destructive\\/20{
    border-color: hsl(var(--destructive) / 0.2) !important;
}
.border-destructive\\/30{
    border-color: hsl(var(--destructive) / 0.3) !important;
}
.border-destructive\\/50{
    border-color: hsl(var(--destructive) / 0.5) !important;
}
.border-input{
    border-color: hsl(var(--input)) !important;
}
.border-muted-foreground{
    border-color: hsl(var(--muted-foreground)) !important;
}
.border-muted-foreground\\/50{
    border-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.border-primary{
    border-color: hsl(var(--primary)) !important;
}
.border-primary\\/20{
    border-color: hsl(var(--primary) / 0.2) !important;
}
.border-primary\\/30{
    border-color: hsl(var(--primary) / 0.3) !important;
}
.border-primary\\/50{
    border-color: hsl(var(--primary) / 0.5) !important;
}
.border-success{
    border-color: hsl(var(--success)) !important;
}
.border-success\\/20{
    border-color: hsl(var(--success) / 0.2) !important;
}
.border-success\\/30{
    border-color: hsl(var(--success) / 0.3) !important;
}
.border-success\\/50{
    border-color: hsl(var(--success) / 0.5) !important;
}
.border-transparent{
    border-color: transparent !important;
}
.border-warning{
    border-color: hsl(var(--warning)) !important;
}
.border-warning\\/20{
    border-color: hsl(var(--warning) / 0.2) !important;
}
.border-warning\\/30{
    border-color: hsl(var(--warning) / 0.3) !important;
}
.border-warning\\/50{
    border-color: hsl(var(--warning) / 0.5) !important;
}
.border-l-transparent{
    border-left-color: transparent !important;
}
.border-t-transparent{
    border-top-color: transparent !important;
}
.bg-\\[--color-bg\\]{
    background-color: var(--color-bg) !important;
}
.bg-\\[hsl\\(var\\(--input\\)\\)\\]{
    background-color: hsl(var(--input)) !important;
}
.bg-accent{
    background-color: hsl(var(--accent)) !important;
}
.bg-background{
    background-color: hsl(var(--background)) !important;
}
.bg-black\\/80{
    background-color: rgb(0 0 0 / 0.8) !important;
}
.bg-border{
    background-color: hsl(var(--border)) !important;
}
.bg-card{
    background-color: hsl(var(--card)) !important;
}
.bg-destructive{
    background-color: hsl(var(--destructive)) !important;
}
.bg-destructive\\/10{
    background-color: hsl(var(--destructive) / 0.1) !important;
}
.bg-destructive\\/20{
    background-color: hsl(var(--destructive) / 0.2) !important;
}
.bg-destructive\\/5{
    background-color: hsl(var(--destructive) / 0.05) !important;
}
.bg-foreground{
    background-color: hsl(var(--foreground)) !important;
}
.bg-muted{
    background-color: hsl(var(--muted)) !important;
}
.bg-muted-foreground\\/50{
    background-color: hsl(var(--muted-foreground) / 0.5) !important;
}
.bg-muted\\/20{
    background-color: hsl(var(--muted) / 0.2) !important;
}
.bg-muted\\/30{
    background-color: hsl(var(--muted) / 0.3) !important;
}
.bg-muted\\/50{
    background-color: hsl(var(--muted) / 0.5) !important;
}
.bg-popover{
    background-color: hsl(var(--popover)) !important;
}
.bg-primary{
    background-color: hsl(var(--primary)) !important;
}
.bg-primary\\/10{
    background-color: hsl(var(--primary) / 0.1) !important;
}
.bg-primary\\/20{
    background-color: hsl(var(--primary) / 0.2) !important;
}
.bg-primary\\/5{
    background-color: hsl(var(--primary) / 0.05) !important;
}
.bg-secondary{
    background-color: hsl(var(--secondary)) !important;
}
.bg-success{
    background-color: hsl(var(--success)) !important;
}
.bg-success\\/10{
    background-color: hsl(var(--success) / 0.1) !important;
}
.bg-success\\/20{
    background-color: hsl(var(--success) / 0.2) !important;
}
.bg-success\\/5{
    background-color: hsl(var(--success) / 0.05) !important;
}
.bg-transparent{
    background-color: transparent !important;
}
.bg-warning{
    background-color: hsl(var(--warning)) !important;
}
.bg-warning\\/10{
    background-color: hsl(var(--warning) / 0.1) !important;
}
.bg-warning\\/20{
    background-color: hsl(var(--warning) / 0.2) !important;
}
.bg-warning\\/5{
    background-color: hsl(var(--warning) / 0.05) !important;
}
.bg-gradient-to-b{
    background-image: linear-gradient(to bottom, var(--tw-gradient-stops)) !important;
}
.bg-gradient-to-r{
    background-image: linear-gradient(to right, var(--tw-gradient-stops)) !important;
}
.from-primary\\/10{
    --tw-gradient-from: hsl(var(--primary) / 0.1) var(--tw-gradient-from-position) !important;
    --tw-gradient-to: hsl(var(--primary) / 0) var(--tw-gradient-to-position) !important;
    --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to) !important;
}
.to-transparent{
    --tw-gradient-to: transparent var(--tw-gradient-to-position) !important;
}
.fill-current{
    fill: currentColor !important;
}
.p-0{
    padding: 0px !important;
}
.p-1{
    padding: 0.25rem !important;
}
.p-2{
    padding: 0.5rem !important;
}
.p-3{
    padding: 0.75rem !important;
}
.p-4{
    padding: 1rem !important;
}
.p-5{
    padding: 1.25rem !important;
}
.p-6{
    padding: 1.5rem !important;
}
.p-8{
    padding: 2rem !important;
}
.p-\\[1px\\]{
    padding: 1px !important;
}
.px-2{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.px-2\\.5{
    padding-left: 0.625rem !important;
    padding-right: 0.625rem !important;
}
.px-3{
    padding-left: 0.75rem !important;
    padding-right: 0.75rem !important;
}
.px-4{
    padding-left: 1rem !important;
    padding-right: 1rem !important;
}
.px-5{
    padding-left: 1.25rem !important;
    padding-right: 1.25rem !important;
}
.px-6{
    padding-left: 1.5rem !important;
    padding-right: 1.5rem !important;
}
.px-8{
    padding-left: 2rem !important;
    padding-right: 2rem !important;
}
.py-0\\.5{
    padding-top: 0.125rem !important;
    padding-bottom: 0.125rem !important;
}
.py-1{
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important;
}
.py-1\\.5{
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
}
.py-2{
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important;
}
.py-3{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
}
.py-4{
    padding-top: 1rem !important;
    padding-bottom: 1rem !important;
}
.py-5{
    padding-top: 1.25rem !important;
    padding-bottom: 1.25rem !important;
}
.py-6{
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important;
}
.pb-0{
    padding-bottom: 0px !important;
}
.pb-2{
    padding-bottom: 0.5rem !important;
}
.pb-3{
    padding-bottom: 0.75rem !important;
}
.pb-4{
    padding-bottom: 1rem !important;
}
.pb-\\[80px\\]{
    padding-bottom: 80px !important;
}
.pe-4{
    padding-inline-end: 1rem !important;
}
.pl-2\\.5{
    padding-left: 0.625rem !important;
}
.pl-4{
    padding-left: 1rem !important;
}
.pl-8{
    padding-left: 2rem !important;
}
.pr-2{
    padding-right: 0.5rem !important;
}
.pr-2\\.5{
    padding-right: 0.625rem !important;
}
.pr-8{
    padding-right: 2rem !important;
}
.ps-2{
    padding-inline-start: 0.5rem !important;
}
.pt-0{
    padding-top: 0px !important;
}
.pt-1{
    padding-top: 0.25rem !important;
}
.pt-2{
    padding-top: 0.5rem !important;
}
.pt-3{
    padding-top: 0.75rem !important;
}
.pt-4{
    padding-top: 1rem !important;
}
.pt-\\[200px\\]{
    padding-top: 200px !important;
}
.text-left{
    text-align: left !important;
}
.text-center{
    text-align: center !important;
}
.text-right{
    text-align: right !important;
}
.text-end{
    text-align: end !important;
}
.align-middle{
    vertical-align: middle !important;
}
.font-mono{
    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace !important;
}
.text-2xl{
    font-size: 1.5rem !important;
    line-height: 2rem !important;
}
.text-3xl{
    font-size: 1.875rem !important;
    line-height: 2.25rem !important;
}
.text-4xl{
    font-size: 2.25rem !important;
    line-height: 2.5rem !important;
}
.text-5xl{
    font-size: 3rem !important;
    line-height: 1 !important;
}
.text-\\[0\\.8rem\\]{
    font-size: 0.8rem !important;
}
.text-\\[10px\\]{
    font-size: 10px !important;
}
.text-\\[9px\\]{
    font-size: 9px !important;
}
.text-base{
    font-size: 1rem !important;
    line-height: 1.5rem !important;
}
.text-lg{
    font-size: 1.125rem !important;
    line-height: 1.75rem !important;
}
.text-sm{
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}
.text-xl{
    font-size: 1.25rem !important;
    line-height: 1.75rem !important;
}
.text-xs{
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}
.font-bold{
    font-weight: 700 !important;
}
.font-medium{
    font-weight: 500 !important;
}
.font-normal{
    font-weight: 400 !important;
}
.font-semibold{
    font-weight: 600 !important;
}
.uppercase{
    text-transform: uppercase !important;
}
.tabular-nums{
    --tw-numeric-spacing: tabular-nums !important;
    font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction) !important;
}
.leading-none{
    line-height: 1 !important;
}
.tracking-tight{
    letter-spacing: -0.025em !important;
}
.tracking-wide{
    letter-spacing: 0.025em !important;
}
.tracking-widest{
    letter-spacing: 0.1em !important;
}
.text-accent-foreground{
    color: hsl(var(--accent-foreground)) !important;
}
.text-card-foreground{
    color: hsl(var(--card-foreground)) !important;
}
.text-current{
    color: currentColor !important;
}
.text-destructive{
    color: hsl(var(--destructive)) !important;
}
.text-destructive-foreground{
    color: hsl(var(--destructive-foreground)) !important;
}
.text-foreground{
    color: hsl(var(--foreground)) !important;
}
.text-foreground\\/50{
    color: hsl(var(--foreground) / 0.5) !important;
}
.text-muted-foreground{
    color: hsl(var(--muted-foreground)) !important;
}
.text-popover-foreground{
    color: hsl(var(--popover-foreground)) !important;
}
.text-primary{
    color: hsl(var(--primary)) !important;
}
.text-primary-foreground{
    color: hsl(var(--primary-foreground)) !important;
}
.text-secondary-foreground{
    color: hsl(var(--secondary-foreground)) !important;
}
.text-success{
    color: hsl(var(--success)) !important;
}
.text-warning{
    color: hsl(var(--warning)) !important;
}
.underline{
    text-decoration-line: underline !important;
}
.line-through{
    text-decoration-line: line-through !important;
}
.underline-offset-4{
    text-underline-offset: 4px !important;
}
.opacity-0{
    opacity: 0 !important;
}
.opacity-50{
    opacity: 0.5 !important;
}
.opacity-60{
    opacity: 0.6 !important;
}
.opacity-70{
    opacity: 0.7 !important;
}
.opacity-90{
    opacity: 0.9 !important;
}
.shadow-lg{
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-md{
    --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-sm{
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.shadow-xl{
    --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.outline-none{
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.outline{
    outline-style: solid !important;
}
.ring-0{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(0px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-2{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.ring-ring{
    --tw-ring-color: hsl(var(--ring)) !important;
}
.ring-offset-background{
    --tw-ring-offset-color: hsl(var(--background)) !important;
}
.grayscale{
    --tw-grayscale: grayscale(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.invert{
    --tw-invert: invert(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.sepia{
    --tw-sepia: sepia(100%) !important;
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.filter{
    filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow) !important;
}
.transition{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-all{
    transition-property: all !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-colors{
    transition-property: color, background-color, border-color, text-decoration-color, fill, stroke !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-opacity{
    transition-property: opacity !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.transition-transform{
    transition-property: transform !important;
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
    transition-duration: 150ms !important;
}
.duration-1000{
    transition-duration: 1000ms !important;
}
.duration-200{
    transition-duration: 200ms !important;
}
.ease-in-out{
    transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}
@keyframes enter{
    from{
        opacity: var(--tw-enter-opacity, 1);
        transform: translate3d(var(--tw-enter-translate-x, 0), var(--tw-enter-translate-y, 0), 0) scale3d(var(--tw-enter-scale, 1), var(--tw-enter-scale, 1), var(--tw-enter-scale, 1)) rotate(var(--tw-enter-rotate, 0));
    }
}
@keyframes exit{
    to{
        opacity: var(--tw-exit-opacity, 1);
        transform: translate3d(var(--tw-exit-translate-x, 0), var(--tw-exit-translate-y, 0), 0) scale3d(var(--tw-exit-scale, 1), var(--tw-exit-scale, 1), var(--tw-exit-scale, 1)) rotate(var(--tw-exit-rotate, 0));
    }
}
.animate-in{
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}
.fade-in-0{
    --tw-enter-opacity: 0 !important;
}
.fade-in-80{
    --tw-enter-opacity: 0.8 !important;
}
.zoom-in-95{
    --tw-enter-scale: .95 !important;
}
.duration-1000{
    animation-duration: 1000ms !important;
}
.duration-200{
    animation-duration: 200ms !important;
}
.ease-in-out{
    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1) !important;
}

/* iframe#webpack-dev-server-client-overlay {display: none;} */

/* =======================================================================
   PROMOTIONIQ SCOPED STYLES
   All styles below are scoped to only apply when PromotionIQ is active
   ======================================================================= */

/* Scoped variables - only apply when PromotionIQ root class is present */
html.promotioniq-root {
  --leftNavWidth: 90px;
  --colorYellow: #fd9f29;
  --colorWhite: #f4f3f2;
  --colorGray: #979a9f;
  --colorDGray: #323232;
  --colorGreen: #1a900a;
  --colorOrange: #e46c0a;
  --colorDOrange: #914507;
}

/* Scoped body styles - only apply within PromotionIQ */
html.promotioniq-root body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Oxygen",
    "Ubuntu", "Cantarell", "Fira Sans", "Droid Sans", "Helvetica Neue",
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

html.promotioniq-root body > iframe {
  display: none !important;
}

html.promotioniq-root code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, "Courier New",
    monospace;
}

/* common - start */
html.promotioniq-root body {
  font-family: "SegoeProDisplay-Regular", sans-serif;
  font-size: 14px;
  background-color: #0c1017;
  color: #f4f3f2;
  position: relative;
}
html.promotioniq-root b {
  font-family: "SegoePro-Bold", sans-serif;
  font-weight: normal;
}
html.promotioniq-root #loading {
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  z-index: 9999;
  left: 0;
  top: 0;
}
html.promotioniq-root #loading img {
  position: fixed;
  left: 50%;
  top: 50%;
  margin-left: -35px;
  margin-top: -35px;
}
html.promotioniq-root .main-wrapper {
  margin-left: 90px; /* Fixed margin - always account for expanded sidebar width */
}
html.promotioniq-root main {
  padding: 0px 35px 40px;
}
html.promotioniq-root button {
  padding: 0;
  border: none;
  background-color: transparent;
}
html.promotioniq-root button.btn {
  border: 1px solid var(--colorYellow);
}
html.promotioniq-root a {
  text-decoration: none;
}
html.promotioniq-root img {
  max-width: 100%;
}
html.promotioniq-root .full-ht {
  height: 100%;
}
html.promotioniq-root button.btn-yellow,
html.promotioniq-root button.btn-transparent,
html.promotioniq-root a.btn-yellow,
html.promotioniq-root a.btn-transparent {
  border: none;
  font-family: "SegoePro-Bold", sans-serif;
  font-size: 16px;
  padding: 10px 30px;
}
html.promotioniq-root button.btn-yellow,
html.promotioniq-root a.btn-yellow,
html.promotioniq-root button.btn.btn-yellow:active,
html.promotioniq-root button.btn.btn-yellow:hover,
html.promotioniq-root button.btn.btn-yellow:focus-visible,
html.promotioniq-root button.btn.btn-yellow:disabled {
  background-color: #fd9f29;
  color: #0c1017;
  border: 1px solid #fd9f29;
}
html.promotioniq-root button.btn.btn-yellow:disabled,
html.promotioniq-root a.btn-yellow:disabled {
  color: rgba(0, 0, 0, 0.4);
}
html.promotioniq-root button.btn-transparent,
html.promotioniq-root a.btn-transparent,
html.promotioniq-root button.btn.btn-transparent:active,
html.promotioniq-root button.btn-transparent:focus,
html.promotioniq-root button.btn-transparent:hover,
html.promotioniq-root button.btn-transparent:focus-visible {
  background-color: transparent;
  color: #fd9f29;
  border: 1px solid #fd9f29;
}
html.promotioniq-root button.btn-small {
  padding: 0 5px;
  font-size: 12px;
  height: 22px;
}
html.promotioniq-root button.btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center
    center;
}
html.promotioniq-root button.btn-transparent-gray,
html.promotioniq-root button.btn-transparent-gray:hover {
  border-color: var(--colorGray);
  color: var(--colorGray);
}
html.promotioniq-root .txt-small {
  font-size: 12px;
}
html.promotioniq-root .txt-red {
  color: #ff0000;
}
html.promotioniq-root .txt-white {
  color: var(--colorWhite);
}
html.promotioniq-root .txt-yellow {
  color: var(--colorYellow);
}
html.promotioniq-root .txt-orange {
  color: var(--colorOrange);
}
html.promotioniq-root .txt-gray {
  color: var(--colorGray);
}
html.promotioniq-root .align-end {
  display: inline-flex;
  height: 100%;
  align-items: flex-end;
}
html.promotioniq-root .bdr-right {
  border-right: 1px solid var(--colorGray);
}
html.promotioniq-root .border-dgray {
  border-color: var(--colorDGray) !important;
}
.chkbox-round {
  width: 25px;
  height: 25px;
  padding: 0;
  position: relative;
  min-height: auto;
}
.chkbox-round.form-check .form-check-input {
  visibility: hidden;
}
.chkbox-round.form-check .form-check-input,
.chkbox-round.form-check label {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  min-width: 25px;
  margin: 0;
  line-height: 25px;
}
.chkbox-round.form-check label {
  border: 1px solid var(--colorYellow);
  cursor: pointer;
  text-align: center;
}
.chkbox-round.chkbox-orange.form-check label {
  border-color: var(--colorOrange);
}
.chkbox-round.chkbox-dorange.form-check label {
  border-color: var(--colorDOrange);
}
.chkbox-round.form-check .form-check-input:checked + label {
  background-color: var(--colorYellow);
  color: #000000;
  font-weight: bold;
}
.chkbox-round.chkbox-orange.form-check .form-check-input:checked + label {
  background-color: var(--colorOrange);
}
.chkbox-round.chkbox-dorange.form-check .form-check-input:checked + label {
  background-color: var(--colorDOrange);
}

.dropdown {
  padding-right: 30px;
  max-width: 100%;
}
.dropdown:after {
  content: "";
  position: absolute;
  display: block;
  width: 10px;
  height: 10px;
  border-top: 1px solid #bfbfbf;
  border-left: 1px solid #bfbfbf;
  transform: rotate(-135deg);
  right: 10px;
  top: 50%;
  margin-top: -8px;
}
.dropdown + .dropdown-list {
  width: 250px;
  max-width: 100%;
  position: absolute;
  z-index: 1;
}
.dropdown-list,
.sub-dropdown-list {
  display: none;
  background-color: #0c1017;
  list-style: none outside;
  padding: 10px 20px;
}
/* .dropdown-list input[type="checkbox"], .sub-dropdown-list input[type="checkbox"]{margin-right: 10px;} */
.dropdown + .dropdown-list > li > .sub-dropdown-list {
  position: absolute;
  width: 100%;
  left: calc(100% + 5px);
  top: 0;
  height: 300px;
  overflow-y: auto;
}
.dropdown.nested + .dropdown-list {
  position: relative;
}
.dropdown.simple + .dropdown-list {
  max-height: 200px;
  overflow-y: auto;
}

.divider {
  display: flex;
  align-items: center;
}
.divider:before,
.divider:after {
  flex: 1 1;
  content: "";
  height: 1px;
  background-color: #212121;
  margin: 5px;
}

/* scrollbar - scoped to PromotionIQ */
html.promotioniq-root ::-webkit-scrollbar {
  width: 5px;
  height: 4px;
}
html.promotioniq-root ::-webkit-scrollbar-track {
  background: #444;
}
html.promotioniq-root ::-webkit-scrollbar-thumb {
  background: #777;
}
html.promotioniq-root ::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/* common - end */

/* leftnav - start */
/* Note: LeftNav styles are global and should remain so as LeftNav is shared across the app */
.leftnav {
  background-color: #191e27;
  position: fixed;
  left: 0;
  top: 0;
  width: var(--leftNavWidth);
  height: 100%;
  text-align: center;
  padding: 25px 5px;
  max-height: 100vh;
  overflow-y: auto;
}
.leftnav .leftnav-logo {
  margin-bottom: 50px;
}
.leftnav ul {
  list-style: none outside;
  padding-left: 0;
}
.leftnav ul li:not(:last-child) {
  margin-bottom: 25px;
}
.leftnav ul li a {
  color: inherit;
  font-size: 11px;
  line-height: 1;
}
.leftnav ul li a:hover img,
.leftnav ul li a.active img {
  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)
    hue-rotate(347deg) brightness(96%) contrast(107%);
}

/* Header icons hover effect */
header .header-right a[title="Support"]:hover img,
header .header-right a[title="Agora"]:hover img,
header .header-right a[title="Atlas"]:hover img {
  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)
    hue-rotate(347deg) brightness(96%) contrast(107%);
}
.leftnav ul li a span {
  display: block;
  margin-top: 5px;
}

.leftnav .show-more {
  transform: rotate(90deg);
}
.leftnav .show-more.show {
  transform: rotate(-90deg);
}
/* collapsed leftnav styles */
body.leftnav-collapsed {
  --leftNavWidth: 50px;
}
body.leftnav-collapsed .leftnav {
  width: var(--leftNavWidth);
}
body.leftnav-collapsed .leftnav ul li a span {
  display: none;
}
.leftnav .collapse-toggle {
  position: absolute;
  left: 0;
  right: 0;
  margin: 0 auto;
  bottom: 70px;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  cursor: pointer;
  transform: rotate(180deg);
}
.leftnav .collapse-toggle img {
  transition: transform 0.2s ease;
  transform: rotate(0deg);
}
body.leftnav-collapsed .leftnav .collapse-toggle img {
  transform: rotate(180deg);
}
/* leftnav - end */

/* header - start - scoped to PromotionIQ */
html.promotioniq-root header {
  padding: 35px;
  margin-bottom: 20px;
}
html.promotioniq-root header h1,
html.promotioniq-root header h2 {
  font-family: "SegoePro-SemiBold", sans-serif;
  font-size: 18px;
  color: var(--colorYellow);
}
html.promotioniq-root header h2 {
  margin-left: 8vw;
}
html.promotioniq-root header .header-left {
  display: flex;
}
html.promotioniq-root header .header-left .company-name:after {
  content: "|";
  margin: 0 10px;
  color: var(--colorGray);
}
html.promotioniq-root header .header-right {
  margin-left: auto;
  display: flex;
  align-items: center;
}

html.promotioniq-root header .header-right .toggle-page .switch {
  position: relative;
  display: inline-block;
  width: 40px;
  min-width: auto;
  height: 20px;
  margin: 0 10px;
}
html.promotioniq-root header .header-right .toggle-page .switch input {
  opacity: 0;
  width: 0;
  height: 0;
}
html.promotioniq-root header .header-right .toggle-page .slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #2c2d2f;
  border: 1px solid var(--colorYellow);
  transition: 0.4s;
}
html.promotioniq-root header .header-right .toggle-page .slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 1px;
  bottom: 1px;
  background-color: var(--colorYellow);
  transition: 0.4s;
}
html.promotioniq-root header .header-right .toggle-page input:checked + .slider:before {
  transform: translateX(20px);
}

header .header-right .notification {
  margin-left: 35px;
  position: relative;
}
header .header-right .notification button {
  position: relative;
}
header .header-right .notification button .count {
  display: none;
}
header .header-right .notification button.notification-true .count {
  position: absolute;
  width: 13px;
  height: 13px;
  background-color: red;
  right: 0;
  top: 2px;
  color: var(--colorWhite);
  font-size: 9px;
  line-height: 13px;
  display: block;
  text-align: center;
}
header .header-right .notification .notification-list {
  display: none;
  visibility: hidden;
  position: absolute;
  width: 210px;
  right: -20px;
  top: 100%;
  margin-top: 5px;
  background-color: #191e27;
  list-style: none outside;
  margin-bottom: 0;
  padding: 0 10px;
  font-size: 12px;
  color: var(--colorGray);
  box-shadow: 0px 3px 6px #00000029;
  z-index: 9;
}
header
  .header-right
  .notification
  button.notification-true
  + .notification-list {
  visibility: visible;
}
header
  .header-right
  .notification
  button.notification-true
  + .notification-list.show {
  display: block;
}
header .header-right .notification .notification-list li {
  padding: 10px 5px 10px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-align: right;
}
header .header-right .notification .notification-list li a {
  color: var(--colorYellow);
  margin-left: auto;
}
header .header-right .notification .notification-list li:not(:last-child) {
  border-bottom: 1px solid #3d4045;
}
header .header-right .notification .notification-list li:before {
  content: "\\2713 ";
  font-size: 9px;
  line-height: 15px;
  color: var(--colorYellow);
  min-width: 15px;
  height: 15px;
  background-color: #3d4045;
  text-align: center;
  margin-right: 15px;
}

header .header-right .user {
  margin-left: 20px;
  padding-left: 20px;
  border-left: 1px solid var(--colorYellow);
  position: relative;
}
header .header-right .user button {
  position: relative;
}
header .header-right .user .user-list {
  display: none;
  visibility: hidden;
  position: absolute;
  width: 100px;
  right: -37px;
  top: 100%;
  margin-top: 5px;
  background-color: #191e27;
  list-style: none outside;
  margin-bottom: 0;
  padding: 0 10px;
  font-size: 12px;
  color: var(--colorGray);
  box-shadow: 0px 3px 6px #00000029;
  z-index: 9;
}
header .header-right .user button.user-true + .user-list {
  visibility: visible;
}
header .header-right .user button.user-true + .user-list.show {
  display: block;
}
header .header-right .user .user-list li {
  padding: 8px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  text-align: left;
}
header .header-right .user .user-list li a {
  color: var(--colorGray);
  margin-left: 0;
}
header .header-right .user .user-list li a:hover {
  color: var(--colorYellow);
}
header .header-right .user .user-list li span {
  cursor: pointer;
  color: var(--colorGray);
}
header .header-right .user .user-list li span:hover {
  color: var(--colorYellow);
}
header .header-right .user .user-list li:not(:last-child) {
  border-bottom: 1px solid #3d4045;
}
/* header - end */

/*modal styles - scoped to PromotionIQ*/
html.promotioniq-root .modal-content {
  padding: 3em; /* font-size:.8em; */
  background: rgba(25, 30, 39, 1);
  color: #f4f3f2;
}
html.promotioniq-root .modal-content .form-text {
  font-size: 10px;
  color: #6c6f74;
}
html.promotioniq-root .modal-content .requestdemo {
  margin-top: -35px;
}
html.promotioniq-root .form-check label {
  color: #979a9f;
  transition: top 2s;
}
html.promotioniq-root .modal-content .formitem {
  position: relative;
}
html.promotioniq-root .modal-content .formitem .form-label {
  position: absolute;
  transition-duration: 1s;
}
html.promotioniq-root .modal-content .formitem .form-label.raisedlabel {
  top: -25px;
}
html.promotioniq-root .modal-footer button,
html.promotioniq-root .modal-footer button:active,
html.promotioniq-root .modal-footer button:focus {
  padding-left: 20px;
  padding-right: 20px;
}
html.promotioniq-root .modal-footer button:active:hover,
html.promotioniq-root .modal-footer button:hover {
  opacity: 0.8;
}
html.promotioniq-root .modal-header {
  border: none;
}
html.promotioniq-root .modal-title {
  color: #fd9f29;
}
html.promotioniq-root .modal-footer {
  border: none;
  justify-content: flex-start;
}
html.promotioniq-root .modal-content .message {
  font-size: 1.1em;
  color: #fd9f29;
}
html.promotioniq-root .modal-content select {
  -webkit-appearance: none;
  -moz-appearance: none;
  background: transparent;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position-x: 100%;
  background-position-y: 5px;
  border-color: #3d4045;
  color: #979a9f;
}
html.promotioniq-root .modal-content button[type="cancel"] {
  background: transparent;
  border: 1px solid #fd9f29;
  color: #fd9f29;
}
html.promotioniq-root .btn-close {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat;
  background-size: cover;
  position: relative;
  z-index: 1;
}
/*modal styles*/



/* =======================================================================
   PROMOTIONIQ MODULE STYLES - SCOPED
   
   All PromotionIQ styles are scoped under .promotioniq-theme and 
   .promotioniq-root to prevent conflicts with platform-ui styles.
   ======================================================================= */

/* PromotionIQ Theme Variables - Scoped to prevent conflicts */
/* Using !important to override Tailwind's default CSS variables from @tailwind base */
html.promotioniq-root,
html.promotioniq-root *,
.promotioniq-theme,
.promotioniq-theme * {
  /* Athena Design Language Colors */
  /* Core backgrounds - #191E27 */
  --background: 218 22% 13% !important;
  /* Foreground text - #F4F3F2 */
  --foreground: 30 9% 95% !important;

  /* Card surfaces - #212429 */
  --card: 216 11% 15% !important;
  --card-foreground: 30 9% 95% !important;

  /* Popover/dropdown - #212429 */
  --popover: 216 11% 15% !important;
  --popover-foreground: 30 9% 95% !important;

  /* Primary - Amber/Orange accent #FD9F29 */
  --primary: 33 98% 58% !important;
  --primary-foreground: 218 22% 13% !important;

  /* Secondary - Slightly lighter dark */
  --secondary: 216 11% 18% !important;
  --secondary-foreground: 30 9% 90% !important;

  /* Muted - Gray #7E7E7E based */
  --muted: 216 11% 20% !important;
  --muted-foreground: 0 0% 49% !important;

  /* Accent - Subtle orange highlight */
  --accent: 33 50% 20% !important;
  --accent-foreground: 33 98% 58% !important;

  /* Destructive - Warning/error */
  --destructive: 0 72% 51% !important;
  --destructive-foreground: 0 0% 100% !important;

  /* Success - Pure Green */
  --success: 142 70% 45% !important;
  --success-foreground: 0 0% 100% !important;

  /* Warning */
  --warning: 45 93% 47% !important;
  --warning-foreground: 218 22% 13% !important;

  /* Borders and inputs */
  --border: 216 11% 22% !important;
  --input: 216 11% 18% !important;
  --ring: 33 98% 58% !important;

  /* Sharp edges - Athena uses edges not curves */
  --radius: 0rem !important;

  /* Sidebar */
  --sidebar-background: 218 22% 11% !important;
  --sidebar-foreground: 30 9% 90% !important;
  --sidebar-primary: 33 98% 58% !important;
  --sidebar-primary-foreground: 218 22% 13% !important;
  --sidebar-accent: 216 11% 16% !important;
  --sidebar-accent-foreground: 30 9% 95% !important;
  --sidebar-border: 216 11% 22% !important;
  --sidebar-ring: 33 98% 58% !important;

  /* Chart colors */
  --chart-1: 33 98% 58% !important;
  --chart-2: 173 80% 40% !important;
  --chart-3: 280 65% 60% !important;
  --chart-4: 45 93% 47% !important;
  --chart-5: 0 72% 51% !important;
}

/* PromotionIQ Component Styles - Scoped */

/* Custom scrollbar for PromotionIQ - Scoped */
.promotioniq-theme ::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.promotioniq-theme ::-webkit-scrollbar-track {
  background-color: hsl(var(--background));
}

.promotioniq-theme ::-webkit-scrollbar-thumb {
  background-color: hsl(var(--muted-foreground) / 0.3);
}

.promotioniq-theme ::-webkit-scrollbar-thumb:hover {
  background-color: hsl(var(--muted-foreground) / 0.5);
}

/* Hide platform-ui elements when PromotionIQ is active */
/* Note: Only hide elements OUTSIDE .promotioniq-theme, not the PromotionIQ header */
/* LeftNav should remain visible */
html.promotioniq-root .main-wrapper,
html.promotioniq-root > body > header {
  display: none;
}

/* Ensure PromotionIQ header is visible */
.promotioniq-theme header {
  display: block !important;
}

/* Set correct body background when PromotionIQ is active */
/* PromotionIQ uses #191E27 (hsl 218 22% 13%) not #0c1017 */
html.promotioniq-root,
html.promotioniq-root body {
  background-color: hsl(218 22% 13%) !important;
  margin: 0;
  padding: 0;
}
.file\\:border-0::file-selector-button{
    border-width: 0px !important;
}
.file\\:bg-transparent::file-selector-button{
    background-color: transparent !important;
}
.file\\:text-sm::file-selector-button{
    font-size: 0.875rem !important;
    line-height: 1.25rem !important;
}
.file\\:font-medium::file-selector-button{
    font-weight: 500 !important;
}
.file\\:text-foreground::file-selector-button{
    color: hsl(var(--foreground)) !important;
}
.placeholder\\:text-muted-foreground::placeholder{
    color: hsl(var(--muted-foreground)) !important;
}
.after\\:absolute::after{
    content: var(--tw-content) !important;
    position: absolute !important;
}
.after\\:inset-y-0::after{
    content: var(--tw-content) !important;
    top: 0px !important;
    bottom: 0px !important;
}
.after\\:left-1\\/2::after{
    content: var(--tw-content) !important;
    left: 50% !important;
}
.after\\:w-1::after{
    content: var(--tw-content) !important;
    width: 0.25rem !important;
}
.after\\:-translate-x-1\\/2::after{
    content: var(--tw-content) !important;
    --tw-translate-x: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.first\\:rounded-l-md:first-child{
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}
.first\\:border-l:first-child{
    border-left-width: 1px !important;
}
.last\\:rounded-r-md:last-child{
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}
.focus-within\\:relative:focus-within{
    position: relative !important;
}
.focus-within\\:z-20:focus-within{
    z-index: 20 !important;
}
.hover\\:scale-\\[1\\.02\\]:hover{
    --tw-scale-x: 1.02 !important;
    --tw-scale-y: 1.02 !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.hover\\:border-destructive:hover{
    border-color: hsl(var(--destructive)) !important;
}
.hover\\:border-primary:hover{
    border-color: hsl(var(--primary)) !important;
}
.hover\\:border-primary\\/50:hover{
    border-color: hsl(var(--primary) / 0.5) !important;
}
.hover\\:border-success:hover{
    border-color: hsl(var(--success)) !important;
}
.hover\\:border-warning:hover{
    border-color: hsl(var(--warning)) !important;
}
.hover\\:bg-accent:hover{
    background-color: hsl(var(--accent)) !important;
}
.hover\\:bg-destructive\\/10:hover{
    background-color: hsl(var(--destructive) / 0.1) !important;
}
.hover\\:bg-destructive\\/20:hover{
    background-color: hsl(var(--destructive) / 0.2) !important;
}
.hover\\:bg-destructive\\/80:hover{
    background-color: hsl(var(--destructive) / 0.8) !important;
}
.hover\\:bg-destructive\\/90:hover{
    background-color: hsl(var(--destructive) / 0.9) !important;
}
.hover\\:bg-muted:hover{
    background-color: hsl(var(--muted)) !important;
}
.hover\\:bg-muted\\/20:hover{
    background-color: hsl(var(--muted) / 0.2) !important;
}
.hover\\:bg-muted\\/40:hover{
    background-color: hsl(var(--muted) / 0.4) !important;
}
.hover\\:bg-muted\\/50:hover{
    background-color: hsl(var(--muted) / 0.5) !important;
}
.hover\\:bg-muted\\/80:hover{
    background-color: hsl(var(--muted) / 0.8) !important;
}
.hover\\:bg-primary:hover{
    background-color: hsl(var(--primary)) !important;
}
.hover\\:bg-primary\\/10:hover{
    background-color: hsl(var(--primary) / 0.1) !important;
}
.hover\\:bg-primary\\/20:hover{
    background-color: hsl(var(--primary) / 0.2) !important;
}
.hover\\:bg-primary\\/5:hover{
    background-color: hsl(var(--primary) / 0.05) !important;
}
.hover\\:bg-primary\\/80:hover{
    background-color: hsl(var(--primary) / 0.8) !important;
}
.hover\\:bg-primary\\/90:hover{
    background-color: hsl(var(--primary) / 0.9) !important;
}
.hover\\:bg-secondary:hover{
    background-color: hsl(var(--secondary)) !important;
}
.hover\\:bg-secondary\\/80:hover{
    background-color: hsl(var(--secondary) / 0.8) !important;
}
.hover\\:bg-success\\/10:hover{
    background-color: hsl(var(--success) / 0.1) !important;
}
.hover\\:bg-success\\/5:hover{
    background-color: hsl(var(--success) / 0.05) !important;
}
.hover\\:bg-warning\\/10:hover{
    background-color: hsl(var(--warning) / 0.1) !important;
}
.hover\\:bg-warning\\/20:hover{
    background-color: hsl(var(--warning) / 0.2) !important;
}
.hover\\:bg-warning\\/5:hover{
    background-color: hsl(var(--warning) / 0.05) !important;
}
.hover\\:text-accent-foreground:hover{
    color: hsl(var(--accent-foreground)) !important;
}
.hover\\:text-foreground:hover{
    color: hsl(var(--foreground)) !important;
}
.hover\\:text-muted-foreground:hover{
    color: hsl(var(--muted-foreground)) !important;
}
.hover\\:text-primary:hover{
    color: hsl(var(--primary)) !important;
}
.hover\\:text-primary-foreground:hover{
    color: hsl(var(--primary-foreground)) !important;
}
.hover\\:text-primary\\/90:hover{
    color: hsl(var(--primary) / 0.9) !important;
}
.hover\\:underline:hover{
    text-decoration-line: underline !important;
}
.hover\\:opacity-100:hover{
    opacity: 1 !important;
}
.focus\\:bg-accent:focus{
    background-color: hsl(var(--accent)) !important;
}
.focus\\:bg-primary:focus{
    background-color: hsl(var(--primary)) !important;
}
.focus\\:text-accent-foreground:focus{
    color: hsl(var(--accent-foreground)) !important;
}
.focus\\:text-primary-foreground:focus{
    color: hsl(var(--primary-foreground)) !important;
}
.focus\\:opacity-100:focus{
    opacity: 1 !important;
}
.focus\\:outline-none:focus{
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.focus\\:ring-2:focus{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus\\:ring-ring:focus{
    --tw-ring-color: hsl(var(--ring)) !important;
}
.focus\\:ring-offset-2:focus{
    --tw-ring-offset-width: 2px !important;
}
.focus-visible\\:outline-none:focus-visible{
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.focus-visible\\:ring-1:focus-visible{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus-visible\\:ring-2:focus-visible{
    --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color) !important;
    --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color) !important;
    box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000) !important;
}
.focus-visible\\:ring-ring:focus-visible{
    --tw-ring-color: hsl(var(--ring)) !important;
}
.focus-visible\\:ring-offset-1:focus-visible{
    --tw-ring-offset-width: 1px !important;
}
.focus-visible\\:ring-offset-2:focus-visible{
    --tw-ring-offset-width: 2px !important;
}
.focus-visible\\:ring-offset-background:focus-visible{
    --tw-ring-offset-color: hsl(var(--background)) !important;
}
.disabled\\:pointer-events-none:disabled{
    pointer-events: none !important;
}
.disabled\\:cursor-not-allowed:disabled{
    cursor: not-allowed !important;
}
.disabled\\:opacity-50:disabled{
    opacity: 0.5 !important;
}
.group:hover .group-hover\\:bg-muted\\/80{
    background-color: hsl(var(--muted) / 0.8) !important;
}
.group:hover .group-hover\\:bg-primary{
    background-color: hsl(var(--primary)) !important;
}
.group:hover .group-hover\\:bg-primary\\/20{
    background-color: hsl(var(--primary) / 0.2) !important;
}
.group:hover .group-hover\\:bg-success\\/20{
    background-color: hsl(var(--success) / 0.2) !important;
}
.group:hover .group-hover\\:bg-warning\\/20{
    background-color: hsl(var(--warning) / 0.2) !important;
}
.group:hover .group-hover\\:text-primary{
    color: hsl(var(--primary)) !important;
}
.group:hover .group-hover\\:text-primary-foreground{
    color: hsl(var(--primary-foreground)) !important;
}
.group:hover .group-hover\\:text-success{
    color: hsl(var(--success)) !important;
}
.group:hover .group-hover\\:text-warning{
    color: hsl(var(--warning)) !important;
}
.group:hover .group-hover\\:opacity-100{
    opacity: 1 !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:border-muted\\/40{
    border-color: hsl(var(--muted) / 0.4) !important;
}
.group.toaster .group-\\[\\.toaster\\]\\:border-border{
    border-color: hsl(var(--border)) !important;
}
.group.toast .group-\\[\\.toast\\]\\:bg-muted{
    background-color: hsl(var(--muted)) !important;
}
.group.toast .group-\\[\\.toast\\]\\:bg-primary{
    background-color: hsl(var(--primary)) !important;
}
.group.toaster .group-\\[\\.toaster\\]\\:bg-background{
    background-color: hsl(var(--background)) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:text-red-300{
    --tw-text-opacity: 1 !important;
    color: rgb(252 165 165 / var(--tw-text-opacity, 1)) !important;
}
.group.toast .group-\\[\\.toast\\]\\:text-muted-foreground{
    color: hsl(var(--muted-foreground)) !important;
}
.group.toast .group-\\[\\.toast\\]\\:text-primary-foreground{
    color: hsl(var(--primary-foreground)) !important;
}
.group.toaster .group-\\[\\.toaster\\]\\:text-foreground{
    color: hsl(var(--foreground)) !important;
}
.group.toaster .group-\\[\\.toaster\\]\\:shadow-lg{
    --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1) !important;
    --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:border-destructive\\/30:hover{
    border-color: hsl(var(--destructive) / 0.3) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:bg-destructive:hover{
    background-color: hsl(var(--destructive)) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-destructive-foreground:hover{
    color: hsl(var(--destructive-foreground)) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:hover\\:text-red-50:hover{
    --tw-text-opacity: 1 !important;
    color: rgb(254 242 242 / var(--tw-text-opacity, 1)) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-destructive:focus{
    --tw-ring-color: hsl(var(--destructive)) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-red-400:focus{
    --tw-ring-opacity: 1 !important;
    --tw-ring-color: rgb(248 113 113 / var(--tw-ring-opacity, 1)) !important;
}
.group.destructive .group-\\[\\.destructive\\]\\:focus\\:ring-offset-red-600:focus{
    --tw-ring-offset-color: #dc2626 !important;
}
.peer:disabled ~ .peer-disabled\\:cursor-not-allowed{
    cursor: not-allowed !important;
}
.peer:disabled ~ .peer-disabled\\:opacity-70{
    opacity: 0.7 !important;
}
.has-\\[\\:disabled\\]\\:opacity-50:has(:disabled){
    opacity: 0.5 !important;
}
.aria-selected\\:bg-accent[aria-selected="true"]{
    background-color: hsl(var(--accent)) !important;
}
.aria-selected\\:bg-accent\\/50[aria-selected="true"]{
    background-color: hsl(var(--accent) / 0.5) !important;
}
.aria-selected\\:text-accent-foreground[aria-selected="true"]{
    color: hsl(var(--accent-foreground)) !important;
}
.aria-selected\\:text-muted-foreground[aria-selected="true"]{
    color: hsl(var(--muted-foreground)) !important;
}
.aria-selected\\:opacity-100[aria-selected="true"]{
    opacity: 1 !important;
}
.aria-selected\\:opacity-30[aria-selected="true"]{
    opacity: 0.3 !important;
}
.data-\\[disabled\\=true\\]\\:pointer-events-none[data-disabled="true"]{
    pointer-events: none !important;
}
.data-\\[disabled\\]\\:pointer-events-none[data-disabled]{
    pointer-events: none !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:h-px[data-panel-group-direction="vertical"]{
    height: 1px !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:w-full[data-panel-group-direction="vertical"]{
    width: 100% !important;
}
.data-\\[side\\=bottom\\]\\:translate-y-1[data-side="bottom"]{
    --tw-translate-y: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[side\\=left\\]\\:-translate-x-1[data-side="left"]{
    --tw-translate-x: -0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[side\\=right\\]\\:translate-x-1[data-side="right"]{
    --tw-translate-x: 0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[side\\=top\\]\\:-translate-y-1[data-side="top"]{
    --tw-translate-y: -0.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[state\\=checked\\]\\:translate-x-5[data-state="checked"]{
    --tw-translate-x: 1.25rem !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[state\\=unchecked\\]\\:translate-x-0[data-state="unchecked"]{
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[swipe\\=cancel\\]\\:translate-x-0[data-swipe="cancel"]{
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[swipe\\=end\\]\\:translate-x-\\[var\\(--radix-toast-swipe-end-x\\)\\][data-swipe="end"]{
    --tw-translate-x: var(--radix-toast-swipe-end-x) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[swipe\\=move\\]\\:translate-x-\\[var\\(--radix-toast-swipe-move-x\\)\\][data-swipe="move"]{
    --tw-translate-x: var(--radix-toast-swipe-move-x) !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
@keyframes accordion-up{
    from{
        height: var(--radix-accordion-content-height);
    }
    to{
        height: 0;
    }
}
.data-\\[state\\=closed\\]\\:animate-accordion-up[data-state="closed"]{
    animation: accordion-up 0.2s ease-out !important;
}
@keyframes accordion-down{
    from{
        height: 0;
    }
    to{
        height: var(--radix-accordion-content-height);
    }
}
.data-\\[state\\=open\\]\\:animate-accordion-down[data-state="open"]{
    animation: accordion-down 0.2s ease-out !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:flex-col[data-panel-group-direction="vertical"]{
    flex-direction: column !important;
}
.data-\\[active\\]\\:bg-accent\\/50[data-active]{
    background-color: hsl(var(--accent) / 0.5) !important;
}
.data-\\[selected\\=\\'true\\'\\]\\:bg-accent[data-selected='true']{
    background-color: hsl(var(--accent)) !important;
}
.data-\\[state\\=active\\]\\:bg-background[data-state="active"]{
    background-color: hsl(var(--background)) !important;
}
.data-\\[state\\=checked\\]\\:bg-primary[data-state="checked"]{
    background-color: hsl(var(--primary)) !important;
}
.data-\\[state\\=on\\]\\:bg-accent[data-state="on"]{
    background-color: hsl(var(--accent)) !important;
}
.data-\\[state\\=on\\]\\:bg-primary[data-state="on"]{
    background-color: hsl(var(--primary)) !important;
}
.data-\\[state\\=open\\]\\:bg-accent[data-state="open"]{
    background-color: hsl(var(--accent)) !important;
}
.data-\\[state\\=open\\]\\:bg-accent\\/50[data-state="open"]{
    background-color: hsl(var(--accent) / 0.5) !important;
}
.data-\\[state\\=open\\]\\:bg-secondary[data-state="open"]{
    background-color: hsl(var(--secondary)) !important;
}
.data-\\[state\\=selected\\]\\:bg-muted[data-state="selected"]{
    background-color: hsl(var(--muted)) !important;
}
.data-\\[state\\=unchecked\\]\\:bg-input[data-state="unchecked"]{
    background-color: hsl(var(--input)) !important;
}
.data-\\[selected\\=true\\]\\:text-accent-foreground[data-selected="true"]{
    color: hsl(var(--accent-foreground)) !important;
}
.data-\\[state\\=active\\]\\:text-foreground[data-state="active"]{
    color: hsl(var(--foreground)) !important;
}
.data-\\[state\\=checked\\]\\:text-primary-foreground[data-state="checked"]{
    color: hsl(var(--primary-foreground)) !important;
}
.data-\\[state\\=on\\]\\:text-accent-foreground[data-state="on"]{
    color: hsl(var(--accent-foreground)) !important;
}
.data-\\[state\\=on\\]\\:text-primary-foreground[data-state="on"]{
    color: hsl(var(--primary-foreground)) !important;
}
.data-\\[state\\=open\\]\\:text-accent-foreground[data-state="open"]{
    color: hsl(var(--accent-foreground)) !important;
}
.data-\\[state\\=open\\]\\:text-muted-foreground[data-state="open"]{
    color: hsl(var(--muted-foreground)) !important;
}
.data-\\[disabled\\=true\\]\\:opacity-50[data-disabled="true"]{
    opacity: 0.5 !important;
}
.data-\\[disabled\\]\\:opacity-50[data-disabled]{
    opacity: 0.5 !important;
}
.data-\\[state\\=active\\]\\:shadow-sm[data-state="active"]{
    --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05) !important;
    --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color) !important;
    box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow) !important;
}
.data-\\[swipe\\=move\\]\\:transition-none[data-swipe="move"]{
    transition-property: none !important;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
    transition-duration: 300ms !important;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
    transition-duration: 500ms !important;
}
.data-\\[motion\\^\\=from-\\]\\:animate-in[data-motion^="from-"]{
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}
.data-\\[state\\=open\\]\\:animate-in[data-state="open"]{
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}
.data-\\[state\\=visible\\]\\:animate-in[data-state="visible"]{
    animation-name: enter !important;
    animation-duration: 150ms !important;
    --tw-enter-opacity: initial !important;
    --tw-enter-scale: initial !important;
    --tw-enter-rotate: initial !important;
    --tw-enter-translate-x: initial !important;
    --tw-enter-translate-y: initial !important;
}
.data-\\[motion\\^\\=to-\\]\\:animate-out[data-motion^="to-"]{
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}
.data-\\[state\\=closed\\]\\:animate-out[data-state="closed"]{
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}
.data-\\[state\\=hidden\\]\\:animate-out[data-state="hidden"]{
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}
.data-\\[swipe\\=end\\]\\:animate-out[data-swipe="end"]{
    animation-name: exit !important;
    animation-duration: 150ms !important;
    --tw-exit-opacity: initial !important;
    --tw-exit-scale: initial !important;
    --tw-exit-rotate: initial !important;
    --tw-exit-translate-x: initial !important;
    --tw-exit-translate-y: initial !important;
}
.data-\\[motion\\^\\=from-\\]\\:fade-in[data-motion^="from-"]{
    --tw-enter-opacity: 0 !important;
}
.data-\\[motion\\^\\=to-\\]\\:fade-out[data-motion^="to-"]{
    --tw-exit-opacity: 0 !important;
}
.data-\\[state\\=closed\\]\\:fade-out-0[data-state="closed"]{
    --tw-exit-opacity: 0 !important;
}
.data-\\[state\\=closed\\]\\:fade-out-80[data-state="closed"]{
    --tw-exit-opacity: 0.8 !important;
}
.data-\\[state\\=hidden\\]\\:fade-out[data-state="hidden"]{
    --tw-exit-opacity: 0 !important;
}
.data-\\[state\\=open\\]\\:fade-in-0[data-state="open"]{
    --tw-enter-opacity: 0 !important;
}
.data-\\[state\\=visible\\]\\:fade-in[data-state="visible"]{
    --tw-enter-opacity: 0 !important;
}
.data-\\[state\\=closed\\]\\:zoom-out-95[data-state="closed"]{
    --tw-exit-scale: .95 !important;
}
.data-\\[state\\=open\\]\\:zoom-in-90[data-state="open"]{
    --tw-enter-scale: .9 !important;
}
.data-\\[state\\=open\\]\\:zoom-in-95[data-state="open"]{
    --tw-enter-scale: .95 !important;
}
.data-\\[motion\\=from-end\\]\\:slide-in-from-right-52[data-motion="from-end"]{
    --tw-enter-translate-x: 13rem !important;
}
.data-\\[motion\\=from-start\\]\\:slide-in-from-left-52[data-motion="from-start"]{
    --tw-enter-translate-x: -13rem !important;
}
.data-\\[motion\\=to-end\\]\\:slide-out-to-right-52[data-motion="to-end"]{
    --tw-exit-translate-x: 13rem !important;
}
.data-\\[motion\\=to-start\\]\\:slide-out-to-left-52[data-motion="to-start"]{
    --tw-exit-translate-x: -13rem !important;
}
.data-\\[side\\=bottom\\]\\:slide-in-from-top-2[data-side="bottom"]{
    --tw-enter-translate-y: -0.5rem !important;
}
.data-\\[side\\=left\\]\\:slide-in-from-right-2[data-side="left"]{
    --tw-enter-translate-x: 0.5rem !important;
}
.data-\\[side\\=right\\]\\:slide-in-from-left-2[data-side="right"]{
    --tw-enter-translate-x: -0.5rem !important;
}
.data-\\[side\\=top\\]\\:slide-in-from-bottom-2[data-side="top"]{
    --tw-enter-translate-y: 0.5rem !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-bottom[data-state="closed"]{
    --tw-exit-translate-y: 100% !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left[data-state="closed"]{
    --tw-exit-translate-x: -100% !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-left-1\\/2[data-state="closed"]{
    --tw-exit-translate-x: -50% !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right[data-state="closed"]{
    --tw-exit-translate-x: 100% !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-right-full[data-state="closed"]{
    --tw-exit-translate-x: 100% !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top[data-state="closed"]{
    --tw-exit-translate-y: -100% !important;
}
.data-\\[state\\=closed\\]\\:slide-out-to-top-\\[48\\%\\][data-state="closed"]{
    --tw-exit-translate-y: -48% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-bottom[data-state="open"]{
    --tw-enter-translate-y: 100% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-left[data-state="open"]{
    --tw-enter-translate-x: -100% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-left-1\\/2[data-state="open"]{
    --tw-enter-translate-x: -50% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-right[data-state="open"]{
    --tw-enter-translate-x: 100% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-top[data-state="open"]{
    --tw-enter-translate-y: -100% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-\\[48\\%\\][data-state="open"]{
    --tw-enter-translate-y: -48% !important;
}
.data-\\[state\\=open\\]\\:slide-in-from-top-full[data-state="open"]{
    --tw-enter-translate-y: -100% !important;
}
.data-\\[state\\=closed\\]\\:duration-300[data-state="closed"]{
    animation-duration: 300ms !important;
}
.data-\\[state\\=open\\]\\:duration-500[data-state="open"]{
    animation-duration: 500ms !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:left-0[data-panel-group-direction="vertical"]::after{
    content: var(--tw-content) !important;
    left: 0px !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:h-1[data-panel-group-direction="vertical"]::after{
    content: var(--tw-content) !important;
    height: 0.25rem !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:w-full[data-panel-group-direction="vertical"]::after{
    content: var(--tw-content) !important;
    width: 100% !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:-translate-y-1\\/2[data-panel-group-direction="vertical"]::after{
    content: var(--tw-content) !important;
    --tw-translate-y: -50% !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.data-\\[panel-group-direction\\=vertical\\]\\:after\\:translate-x-0[data-panel-group-direction="vertical"]::after{
    content: var(--tw-content) !important;
    --tw-translate-x: 0px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.group[data-state="open"] .group-data-\\[state\\=open\\]\\:rotate-180{
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.dark\\:border-destructive:is(.dark *){
    border-color: hsl(var(--destructive)) !important;
}
@media (min-width: 640px){
    .sm\\:bottom-0{
        bottom: 0px !important;
    }
    .sm\\:right-0{
        right: 0px !important;
    }
    .sm\\:top-auto{
        top: auto !important;
    }
    .sm\\:mt-0{
        margin-top: 0px !important;
    }
    .sm\\:max-w-sm{
        max-width: 24rem !important;
    }
    .sm\\:flex-row{
        flex-direction: row !important;
    }
    .sm\\:flex-col{
        flex-direction: column !important;
    }
    .sm\\:justify-end{
        justify-content: flex-end !important;
    }
    .sm\\:gap-2\\.5{
        gap: 0.625rem !important;
    }
    .sm\\:space-x-2 > :not([hidden]) ~ :not([hidden]){
        --tw-space-x-reverse: 0 !important;
        margin-right: calc(0.5rem * var(--tw-space-x-reverse)) !important;
        margin-left: calc(0.5rem * calc(1 - var(--tw-space-x-reverse))) !important;
    }
    .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]){
        --tw-space-x-reverse: 0 !important;
        margin-right: calc(1rem * var(--tw-space-x-reverse)) !important;
        margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse))) !important;
    }
    .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]){
        --tw-space-y-reverse: 0 !important;
        margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse))) !important;
        margin-bottom: calc(0px * var(--tw-space-y-reverse)) !important;
    }
    .sm\\:rounded-lg{
        border-radius: 0px !important;
    }
    .sm\\:text-left{
        text-align: left !important;
    }
    .data-\\[state\\=open\\]\\:sm\\:slide-in-from-bottom-full[data-state="open"]{
        --tw-enter-translate-y: 100% !important;
    }
}
@media (min-width: 768px){
    .md\\:absolute{
        position: absolute !important;
    }
    .md\\:w-\\[var\\(--radix-navigation-menu-viewport-width\\)\\]{
        width: var(--radix-navigation-menu-viewport-width) !important;
    }
    .md\\:w-auto{
        width: auto !important;
    }
    .md\\:max-w-\\[420px\\]{
        max-width: 420px !important;
    }
    .md\\:grid-cols-2{
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-3{
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-4{
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .md\\:grid-cols-5{
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }
    .md\\:text-sm{
        font-size: 0.875rem !important;
        line-height: 1.25rem !important;
    }
}
@media (min-width: 1024px){
    .lg\\:col-span-2{
        grid-column: span 2 / span 2 !important;
    }
    .lg\\:inline{
        display: inline !important;
    }
    .lg\\:grid-cols-2{
        grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-3{
        grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-4{
        grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
    }
    .lg\\:grid-cols-5{
        grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
    }
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:bg-accent:has([aria-selected]){
    background-color: hsl(var(--accent)) !important;
}
.first\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-l-md:has([aria-selected]):first-child{
    border-top-left-radius: 0px !important;
    border-bottom-left-radius: 0px !important;
}
.last\\:\\[\\&\\:has\\(\\[aria-selected\\]\\)\\]\\:rounded-r-md:has([aria-selected]):last-child{
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-outside\\)\\]\\:bg-accent\\/50:has([aria-selected].day-outside){
    background-color: hsl(var(--accent) / 0.5) !important;
}
.\\[\\&\\:has\\(\\[aria-selected\\]\\.day-range-end\\)\\]\\:rounded-r-md:has([aria-selected].day-range-end){
    border-top-right-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
}
.\\[\\&\\:has\\(\\[role\\=checkbox\\]\\)\\]\\:pr-0:has([role=checkbox]){
    padding-right: 0px !important;
}
.\\[\\&\\>span\\]\\:line-clamp-1>span{
    overflow: hidden !important;
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    -webkit-line-clamp: 1 !important;
}
.\\[\\&\\>svg\\+div\\]\\:translate-y-\\[-3px\\]>svg+div{
    --tw-translate-y: -3px !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\[\\&\\>svg\\]\\:absolute>svg{
    position: absolute !important;
}
.\\[\\&\\>svg\\]\\:left-4>svg{
    left: 1rem !important;
}
.\\[\\&\\>svg\\]\\:top-4>svg{
    top: 1rem !important;
}
.\\[\\&\\>svg\\]\\:size-3\\.5>svg{
    width: 0.875rem !important;
    height: 0.875rem !important;
}
.\\[\\&\\>svg\\]\\:h-2\\.5>svg{
    height: 0.625rem !important;
}
.\\[\\&\\>svg\\]\\:h-3>svg{
    height: 0.75rem !important;
}
.\\[\\&\\>svg\\]\\:w-2\\.5>svg{
    width: 0.625rem !important;
}
.\\[\\&\\>svg\\]\\:w-3>svg{
    width: 0.75rem !important;
}
.\\[\\&\\>svg\\]\\:text-destructive>svg{
    color: hsl(var(--destructive)) !important;
}
.\\[\\&\\>svg\\]\\:text-foreground>svg{
    color: hsl(var(--foreground)) !important;
}
.\\[\\&\\>svg\\]\\:text-muted-foreground>svg{
    color: hsl(var(--muted-foreground)) !important;
}
.\\[\\&\\>svg\\~\\*\\]\\:pl-7>svg~*{
    padding-left: 1.75rem !important;
}
.\\[\\&\\>tr\\]\\:last\\:border-b-0:last-child>tr{
    border-bottom-width: 0px !important;
}
.\\[\\&\\[data-panel-group-direction\\=vertical\\]\\>div\\]\\:rotate-90[data-panel-group-direction=vertical]>div{
    --tw-rotate: 90deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\[\\&\\[data-state\\=open\\]\\>svg\\]\\:rotate-180[data-state=open]>svg{
    --tw-rotate: 180deg !important;
    transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y)) !important;
}
.\\[\\&_\\.recharts-cartesian-axis-tick_text\\]\\:fill-muted-foreground .recharts-cartesian-axis-tick text{
    fill: hsl(var(--muted-foreground)) !important;
}
.\\[\\&_\\.recharts-cartesian-grid_line\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border\\/50 .recharts-cartesian-grid line[stroke='#ccc']{
    stroke: hsl(var(--border) / 0.5) !important;
}
.\\[\\&_\\.recharts-curve\\.recharts-tooltip-cursor\\]\\:stroke-border .recharts-curve.recharts-tooltip-cursor{
    stroke: hsl(var(--border)) !important;
}
.\\[\\&_\\.recharts-dot\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-dot[stroke='#fff']{
    stroke: transparent !important;
}
.\\[\\&_\\.recharts-layer\\]\\:outline-none .recharts-layer{
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.\\[\\&_\\.recharts-polar-grid_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-polar-grid [stroke='#ccc']{
    stroke: hsl(var(--border)) !important;
}
.\\[\\&_\\.recharts-radial-bar-background-sector\\]\\:fill-muted .recharts-radial-bar-background-sector{
    fill: hsl(var(--muted)) !important;
}
.\\[\\&_\\.recharts-rectangle\\.recharts-tooltip-cursor\\]\\:fill-muted .recharts-rectangle.recharts-tooltip-cursor{
    fill: hsl(var(--muted)) !important;
}
.\\[\\&_\\.recharts-reference-line_\\[stroke\\=\\'\\#ccc\\'\\]\\]\\:stroke-border .recharts-reference-line [stroke='#ccc']{
    stroke: hsl(var(--border)) !important;
}
.\\[\\&_\\.recharts-sector\\[stroke\\=\\'\\#fff\\'\\]\\]\\:stroke-transparent .recharts-sector[stroke='#fff']{
    stroke: transparent !important;
}
.\\[\\&_\\.recharts-sector\\]\\:outline-none .recharts-sector{
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.\\[\\&_\\.recharts-surface\\]\\:outline-none .recharts-surface{
    outline: 2px solid transparent !important;
    outline-offset: 2px !important;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:px-2 [cmdk-group-heading]{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:py-1\\.5 [cmdk-group-heading]{
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-xs [cmdk-group-heading]{
    font-size: 0.75rem !important;
    line-height: 1rem !important;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:font-medium [cmdk-group-heading]{
    font-weight: 500 !important;
}
.\\[\\&_\\[cmdk-group-heading\\]\\]\\:text-muted-foreground [cmdk-group-heading]{
    color: hsl(var(--muted-foreground)) !important;
}
.\\[\\&_\\[cmdk-group\\]\\:not\\(\\[hidden\\]\\)_\\~\\[cmdk-group\\]\\]\\:pt-0 [cmdk-group]:not([hidden]) ~[cmdk-group]{
    padding-top: 0px !important;
}
.\\[\\&_\\[cmdk-group\\]\\]\\:px-2 [cmdk-group]{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:h-5 [cmdk-input-wrapper] svg{
    height: 1.25rem !important;
}
.\\[\\&_\\[cmdk-input-wrapper\\]_svg\\]\\:w-5 [cmdk-input-wrapper] svg{
    width: 1.25rem !important;
}
.\\[\\&_\\[cmdk-input\\]\\]\\:h-12 [cmdk-input]{
    height: 3rem !important;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:px-2 [cmdk-item]{
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
}
.\\[\\&_\\[cmdk-item\\]\\]\\:py-3 [cmdk-item]{
    padding-top: 0.75rem !important;
    padding-bottom: 0.75rem !important;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:h-5 [cmdk-item] svg{
    height: 1.25rem !important;
}
.\\[\\&_\\[cmdk-item\\]_svg\\]\\:w-5 [cmdk-item] svg{
    width: 1.25rem !important;
}
.\\[\\&_p\\]\\:leading-relaxed p{
    line-height: 1.625 !important;
}
.\\[\\&_svg\\]\\:pointer-events-none svg{
    pointer-events: none !important;
}
.\\[\\&_svg\\]\\:size-4 svg{
    width: 1rem !important;
    height: 1rem !important;
}
.\\[\\&_svg\\]\\:shrink-0 svg{
    flex-shrink: 0 !important;
}
.\\[\\&_tr\\:last-child\\]\\:border-0 tr:last-child{
    border-width: 0px !important;
}
.\\[\\&_tr\\]\\:border-b tr{
    border-bottom-width: 1px !important;
}
`, "",{"version":3,"sources":["webpack://./src/assets/css/PromotionIQ/style.css"],"names":[],"mappings":";AAGA,mDAAmD;AACnD;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AAAd;IAAA,wBAAc;IAAd,wBAAc;IAAd,mBAAc;IAAd,mBAAc;IAAd,cAAc;IAAd,cAAc;IAAd,cAAc;IAAd,eAAc;IAAd,eAAc;IAAd,aAAc;IAAd,aAAc;IAAd,kBAAc;IAAd,sCAAc;IAAd,8BAAc;IAAd,6BAAc;IAAd,4BAAc;IAAd,eAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,kBAAc;IAAd,2BAAc;IAAd,4BAAc;IAAd,sCAAc;IAAd,kCAAc;IAAd,2BAAc;IAAd,sBAAc;IAAd,8BAAc;IAAd,YAAc;IAAd,kBAAc;IAAd,gBAAc;IAAd,iBAAc;IAAd,kBAAc;IAAd,cAAc;IAAd,gBAAc;IAAd,aAAc;IAAd,mBAAc;IAAd,qBAAc;IAAd,2BAAc;IAAd,yBAAc;IAAd,0BAAc;IAAd,2BAAc;IAAd,uBAAc;IAAd,wBAAc;IAAd,yBAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,sBAAc;IAAd,qBAAc;IAAd;AAAc;AACd;IAAA,WAAoB;IAApB,kBAAoB;IAApB,iBAAoB;IAApB,mBAAoB;IAApB;AAAoB;AAApB;IAAA;QAAA;IAAoB;AAAA;AAuuBlB,0CAA0C;AAC1C;IACE,4DAA4D;IAC5D,0DAA0D;;IAE1D,8CAA8C;IAC9C,iBAAiB;IACjB,wCAAwC;IACxC,6BAA6B;EAC/B;AAEA,2DAA2D;AAC3D,yEAAyE;AACzE;;;IAGE,sBAAsB;IACtB,eAAe;IACf,mBAAmB;IACnB,gCAAgC;EAClC;AAEA;IACE,gBAAgB;IAChB,8BAA8B;IAE9B,WAAW;EACb;AAEA;IACE,SAAS;IACT,cAAc;IACd,qBAAqB;EACvB;AAEA;IACE,iCAAiC;EACnC;AAEA;;IAEE,mBAAmB;EACrB;AAEA;;;;IAIE,+GAA+G;IAC/G,cAAc;EAChB;AAEA;IACE,cAAc;EAChB;AAEA;;IAEE,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,wBAAwB;EAC1B;AAEA;IACE,eAAe;EACjB;AAEA;IACE,WAAW;EACb;AAEA;IACE,cAAc;IACd,qBAAqB;IACrB,yBAAyB;EAC3B;AAEA;;;;;IAKE,oBAAoB;IACpB,8BAA8B;IAC9B,gCAAgC;IAChC,eAAe;IACf,oBAAoB;IACpB,oBAAoB;IACpB,cAAc;IACd,SAAS;IACT,UAAU;EACZ;AAEA;;IAEE,oBAAoB;EACtB;AAEA;;;;IAIE,0BAA0B;IAC1B,6BAA6B;IAC7B,sBAAsB;EACxB;AAEA;IACE,aAAa;EACf;AAEA;IACE,gBAAgB;EAClB;AAEA;IACE,wBAAwB;EAC1B;AAEA;;IAEE,YAAY;EACd;AAEA;IACE,6BAA6B;IAC7B,oBAAoB;EACtB;AAEA;IACE,wBAAwB;EAC1B;AAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;AAEA;IACE,kBAAkB;EACpB;AAEA;;;;;;;;;;;;;IAaE,SAAS;EACX;AAEA;IACE,SAAS;IACT,UAAU;EACZ;AAEA;IACE,UAAU;EACZ;AAEA;;;IAGE,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;AAEA;IACE,UAAU;EACZ;AAEA;IACE,gBAAgB;EAClB;AAEA;;IAEE,UAAU;IACV,mCAAmC;EACrC;AAEA;;IAEE,eAAe;EACjB;AAEA;IACE,eAAe;EACjB;AAEA;;;;;;;;IAQE,cAAc;IACd,sBAAsB;EACxB;AAEA;;IAEE,eAAe;IACf,YAAY;EACd;AAEA;IACE,aAAa;EACf;AAEA;;;;;;IAME,0DAA0D;IAC1D,gBAAgB;IAChB,wBAAwB;IACxB,cAAc;EAChB;AAEA;IACE,cAAc;IACd,qBAAqB;EACvB;AAEA;IACE,oBAAoB;EACtB;AAEA,8BAA8B;AAC9B;IACE,WAAW;IACX,yBAAyB;EAC3B;AAEA;IACE,kDAAkD;EACpD;AAEA;IACE,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;EAC5B;AAEA;IACE,iDAAiD;IACjD,kCAAkC;EACpC;AAEA;IACE,yCAAyC;EAC3C;AAEA;IACE,wCAAwC;EAC1C;AAEA;IACE,qBAAqB;IACrB,mBAAmB;IACnB,6BAA6B;EAC/B;AAEA,iBAAiB;AACjB;IACE,oCAAoC;IACpC,kCAAkC;IAClC,eAAe;IACf,8BAA8B;EAChC;AAEA;IACE,uCAAuC;EACzC;AAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;EAC5B;AAEA;IACE,mBAAmB;IACnB,mCAAmC;EACrC;AAEA,kBAAkB;AAClB;IACE,oBAAoB;IACpB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,gBAAgB;EAClB;AAEA;IACE,2CAA2C;IAC3C,0BAA0B;EAC5B;AAEA;IACE,2CAA2C;IAC3C,0BAA0B;EAC5B;AAEA;IACE,+CAA+C;IAC/C,8BAA8B;EAChC;AAEA,iCAAiC;AACjC;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,6BAA6B;IAC7B,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;IAC1B,qBAAqB;EACvB;AAEA;IACE,qCAAqC;IACrC,qCAAqC;EACvC;AAEA;IACE,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,qCAAqC;IACrC,qBAAqB;EACvB;AAEA;IACE,2CAA2C;EAC7C;AAEA,6BAA6B;AAC7B;IACE,WAAW;IACX,oCAAoC;IACpC,mCAAmC;IACnC,oBAAoB;IACpB,6BAA6B;EAC/B;AAEA;IACE,mCAAmC;EACrC;AAEA;IACE,iCAAiC;IACjC,aAAa;IACb,yCAAyC;EAC3C;AAEA;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;EAC5B;AAEA,oBAAoB;AACpB;IACE,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,gBAAgB;IAChB,mCAAmC;IACnC,uBAAuB;EACzB;AAEA;IACE,6BAA6B;EAC/B;AAEA;IACE,0BAA0B;EAC5B;AAFA;IACE,qCAA0B;EAC5B;AAEA;IACE,WAAW;IACX,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,QAAQ;IACR,WAAW;IACX,qCAAqC;EACvC;AARA;IACE,sBAAW;IACX,6BAAkB;IAClB,oBAAS;IACT,kBAAO;IACP,mBAAQ;IACR,sBAAW;IACX,gDAAqC;EACvC;AAEA,oBAAoB;AACpB;IACE,mBAAmB;IACnB,gBAAgB;IAChB,0BAA0B;EAC5B;AAEA,iBAAiB;AACjB;IACE,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,6BAA6B;EAC/B;AAEA;IACE,cAAc;IACd,eAAe;EACjB;AA1pCF;IAAA,6BAAmB;IAAnB,qBAAmB;IAAnB,sBAAmB;IAAnB,qBAAmB;IAAnB,uBAAmB;IAAnB,2BAAmB;IAAnB,iCAAmB;IAAnB,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oBAAmB;IAAnB;AAAmB;AAAnB;IAAA,mBAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,2BAAmB;IAAnB,+BAAmB;IAAnB,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;IAAnB;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA;IAAmB;AAAA;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,oCAAmB;YAAnB;AAAmB;AAAnB;IAAA,mCAAmB;YAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,+DAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,2EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,0EAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,uEAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB,yEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,yFAAmB;IAAnB,mFAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,iCAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,gCAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,+BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,4BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,8BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA,6BAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,6CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0FAAmB;IAAnB,8GAAmB;IAAnB;AAAmB;AAAnB;IAAA,wFAAmB;IAAnB,4GAAmB;IAAnB;AAAmB;AAAnB;IAAA,qDAAmB;IAAnB,kEAAmB;IAAnB;AAAmB;AAAnB;IAAA,2FAAmB;IAAnB,+GAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA,sHAAmB;IAAnB,oHAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA,oCAAmB;IAAnB;AAAmB;AAAnB;IAAA,kCAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA,mKAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,mCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,0GAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,uCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA,yCAAmB;IAAnB,mEAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;QAAA,mCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA;QAAA,kCAAmB;QAAnB;IAAmB;AAAA;AAAnB;IAAA,gCAAmB;IAAnB,oCAAmB;IAAnB,sCAAmB;IAAnB,oCAAmB;IAAnB,qCAAmB;IAAnB,0CAAmB;IAAnB;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;AAAnB;IAAA;AAAmB;;AAEnB,8DAA8D;;AAE9D;;;4EAG4E;;AAE5E,yEAAyE;AACzE;EACE,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,oBAAoB;EACpB,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA,uDAAuD;AACvD;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;aACW;AACb;;AAEA,mBAAmB;AACnB;EACE,kDAAkD;EAClD,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,wCAAwC;EACxC,mBAAmB;AACrB;AACA;EACE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,OAAO;EACP,MAAM;AACR;AACA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB,EAAE,6DAA6D;AAClF;AACA;EACE,sBAAsB;AACxB;AACA;EACE,UAAU;EACV,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qBAAqB;AACvB;AACA;EACE,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;;;;EAIE,YAAY;EACZ,wCAAwC;EACxC,eAAe;EACf,kBAAkB;AACpB;AACA;;;;;;EAME,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;AACA;;EAEE,yBAAyB;AAC3B;AACA;;;;;;EAME,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;AACA;EACE,cAAc;EACd,eAAe;EACf,YAAY;AACd;AACA;EACE;UACQ;AACV;AACA;;EAEE,8BAA8B;EAC9B,uBAAuB;AACzB;AACA;EACE,eAAe;AACjB;AACA;EACE,cAAc;AAChB;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;AACvB;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,0CAA0C;AAC5C;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,OAAO;EACP,MAAM;EACN,eAAe;EACf,SAAS;EACT,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,oCAAoC;EACpC,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,0BAA0B;EAC1B,WAAW;EACX,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,aAAa;EACb,yBAAyB;EACzB,wBAAwB;EACxB,kBAAkB;AACpB;AACA,0GAA0G;AAC1G;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,MAAM;EACN,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,SAAO;EACP,WAAW;EACX,WAAW;EACX,yBAAyB;EACzB,WAAW;AACb;;AAEA,sCAAsC;AACtC;EACE,UAAU;EACV,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA,iBAAiB;;AAEjB,oBAAoB;AACpB,6FAA6F;AAC7F;EACE,yBAAyB;EACzB,eAAe;EACf,OAAO;EACP,MAAM;EACN,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,wBAAwB;EACxB,eAAe;AACjB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;;EAEE;qDACmD;AACrD;;AAEA,8BAA8B;AAC9B;;;EAGE;qDACmD;AACrD;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;AACA;EACE,yBAAyB;AAC3B;AACA,6BAA6B;AAC7B;EACE,oBAAoB;AACtB;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,cAAc;EACd,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA,kBAAkB;;AAElB,2CAA2C;AAC3C;EACE,aAAa;EACb,mBAAmB;AACrB;AACA;;EAEE,4CAA4C;EAC5C,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;EACZ,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;AACA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,yBAAyB;EACzB,oCAAoC;EAEpC,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,oCAAoC;EACpC,gBAAgB;AAClB;AACA;EAGE,2BAA2B;AAC7B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,QAAQ;EACR,QAAQ;EACR,wBAAwB;EACxB,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,UAAU;AACZ;AACA;;;;;EAKE,mBAAmB;AACrB;AACA;;;;;EAKE,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,iBAAiB;EACjB,cAAc;EACd,iBAAiB;EACjB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,eAAe;EACf,yBAAyB;EACzB,wBAAwB;EACxB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,uBAAuB;EACvB,iCAAiC;EACjC,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,uBAAuB;AACzB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;AAClC;AACA,iBAAiB;;AAEjB,uCAAuC;AACvC;EACE,YAAY,EAAE,oBAAoB;EAClC,+BAA+B;EAC/B,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;AACA;EACE,UAAU;AACZ;AACA;;;EAGE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;;EAEE,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,wBAAwB;EACxB,qBAAqB;EACrB,uBAAuB;EACvB,yDAAqN;EACrN,4BAA4B;EAC5B,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,uBAAuB;EACvB,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,6DAA8D;EAC9D,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;AACZ;AACA,eAAe;;;;AAIf;;;;;4EAK4E;;AAE5E,8DAA8D;AAC9D,sFAAsF;AACtF;;;;EAIE,kCAAkC;EAClC,+BAA+B;EAC/B,oCAAoC;EACpC,8BAA8B;EAC9B,kCAAkC;;EAElC,4BAA4B;EAC5B,8BAA8B;EAC9B,uCAAuC;;EAEvC,+BAA+B;EAC/B,iCAAiC;EACjC,0CAA0C;;EAE1C,0CAA0C;EAC1C,gCAAgC;EAChC,4CAA4C;;EAE5C,sCAAsC;EACtC,mCAAmC;EACnC,4CAA4C;;EAE5C,+BAA+B;EAC/B,+BAA+B;EAC/B,uCAAuC;;EAEvC,qCAAqC;EACrC,+BAA+B;EAC/B,0CAA0C;;EAE1C,gCAAgC;EAChC,mCAAmC;EACnC,8CAA8C;;EAE9C,yBAAyB;EACzB,iCAAiC;EACjC,0CAA0C;;EAE1C,YAAY;EACZ,gCAAgC;EAChC,4CAA4C;;EAE5C,uBAAuB;EACvB,gCAAgC;EAChC,+BAA+B;EAC/B,6BAA6B;;EAE7B,+CAA+C;EAC/C,yBAAyB;;EAEzB,YAAY;EACZ,4CAA4C;EAC5C,0CAA0C;EAC1C,wCAAwC;EACxC,oDAAoD;EACpD,wCAAwC;EACxC,iDAAiD;EACjD,wCAAwC;EACxC,qCAAqC;;EAErC,iBAAiB;EACjB,gCAAgC;EAChC,iCAAiC;EACjC,iCAAiC;EACjC,gCAAgC;EAChC,+BAA+B;AACjC;;AAEA,0CAA0C;;AAyb1C,8CAA8C;AAC9C;EACE,UAAU;EACV,WAAW;AACb;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,oDAAoD;AACtD;;AAEA;EACE,oDAAoD;AACtD;;AAEA,yDAAyD;AACzD,oFAAoF;AACpF,kCAAkC;AAClC;;EAEE,aAAa;AACf;;AAEA,yCAAyC;AACzC;EACE,yBAAyB;AAC3B;;AAEA,2DAA2D;AAC3D,2DAA2D;AAC3D;;EAEE,6CAA6C;EAC7C,SAAS;EACT,UAAU;AACZ;AAzsCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,8BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA,mBA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA,iCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,sCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,uCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,6BA0sCA;IA1sCA,6BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,sHA0sCA;IA1sCA,oHA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,sHA0sCA;IA1sCA,oHA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,sHA0sCA;IA1sCA,oHA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,0FA0sCA;IA1sCA,8GA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,oCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,oCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,oCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,gCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,gCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,2DA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,4DA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;AAAA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;AAAA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,qDA0sCA;IA1sCA,kEA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,gCA0sCA;IA1sCA,oCA0sCA;IA1sCA,sCA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,0CA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,gCA0sCA;IA1sCA,oCA0sCA;IA1sCA,sCA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,0CA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,gCA0sCA;IA1sCA,oCA0sCA;IA1sCA,sCA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,0CA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,mCA0sCA;IA1sCA,oCA0sCA;IA1sCA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,mCA0sCA;IA1sCA,oCA0sCA;IA1sCA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,mCA0sCA;IA1sCA,oCA0sCA;IA1sCA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA,oCA0sCA;IA1sCA,qCA0sCA;IA1sCA,mCA0sCA;IA1sCA,oCA0sCA;IA1sCA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA,iCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,qCA0sCA;IA1sCA,gCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,8BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA,kCA0sCA;QA1sCA,iEA0sCA;QA1sCA;IA0sCA;IA1sCA;QAAA,kCA0sCA;QA1sCA,+DA0sCA;QA1sCA;IA0sCA;IA1sCA;QAAA,kCA0sCA;QA1sCA,sEA0sCA;QA1sCA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;AAAA;AA1sCA;IAAA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA,8BA0sCA;QA1sCA;IA0sCA;AAAA;AA1sCA;IAAA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;IA1sCA;QAAA;IA0sCA;AAAA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,sCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,uCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,uCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,2BA0sCA;IA1sCA,+BA0sCA;IA1sCA,uCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,iCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,0BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,6BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,8BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,yCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,gCA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,6BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA,+BA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA,sBA0sCA;IA1sCA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA;AA1sCA;IAAA;AA0sCA","sourcesContent":["\n@import \"../../fonts/fonts.css\";\n\n/* Tailwind CSS - Required for PromotionIQ module */\n@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* iframe#webpack-dev-server-client-overlay {display: none;} */\n\n/* =======================================================================\n   PROMOTIONIQ SCOPED STYLES\n   All styles below are scoped to only apply when PromotionIQ is active\n   ======================================================================= */\n\n/* Scoped variables - only apply when PromotionIQ root class is present */\nhtml.promotioniq-root {\n  --leftNavWidth: 90px;\n  --colorYellow: #fd9f29;\n  --colorWhite: #f4f3f2;\n  --colorGray: #979a9f;\n  --colorDGray: #323232;\n  --colorGreen: #1a900a;\n  --colorOrange: #e46c0a;\n  --colorDOrange: #914507;\n}\n\n/* Scoped body styles - only apply within PromotionIQ */\nhtml.promotioniq-root body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\",\n    \"Ubuntu\", \"Cantarell\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\",\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\nhtml.promotioniq-root body > iframe {\n  display: none !important;\n}\n\nhtml.promotioniq-root code {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, \"Courier New\",\n    monospace;\n}\n\n/* common - start */\nhtml.promotioniq-root body {\n  font-family: \"SegoeProDisplay-Regular\", sans-serif;\n  font-size: 14px;\n  background-color: #0c1017;\n  color: #f4f3f2;\n  position: relative;\n}\nhtml.promotioniq-root b {\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-weight: normal;\n}\nhtml.promotioniq-root #loading {\n  position: fixed;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  z-index: 9999;\n  left: 0;\n  top: 0;\n}\nhtml.promotioniq-root #loading img {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  margin-left: -35px;\n  margin-top: -35px;\n}\nhtml.promotioniq-root .main-wrapper {\n  margin-left: 90px; /* Fixed margin - always account for expanded sidebar width */\n}\nhtml.promotioniq-root main {\n  padding: 0px 35px 40px;\n}\nhtml.promotioniq-root button {\n  padding: 0;\n  border: none;\n  background-color: transparent;\n}\nhtml.promotioniq-root button.btn {\n  border: 1px solid var(--colorYellow);\n}\nhtml.promotioniq-root a {\n  text-decoration: none;\n}\nhtml.promotioniq-root img {\n  max-width: 100%;\n}\nhtml.promotioniq-root .full-ht {\n  height: 100%;\n}\nhtml.promotioniq-root button.btn-yellow,\nhtml.promotioniq-root button.btn-transparent,\nhtml.promotioniq-root a.btn-yellow,\nhtml.promotioniq-root a.btn-transparent {\n  border: none;\n  font-family: \"SegoePro-Bold\", sans-serif;\n  font-size: 16px;\n  padding: 10px 30px;\n}\nhtml.promotioniq-root button.btn-yellow,\nhtml.promotioniq-root a.btn-yellow,\nhtml.promotioniq-root button.btn.btn-yellow:active,\nhtml.promotioniq-root button.btn.btn-yellow:hover,\nhtml.promotioniq-root button.btn.btn-yellow:focus-visible,\nhtml.promotioniq-root button.btn.btn-yellow:disabled {\n  background-color: #fd9f29;\n  color: #0c1017;\n  border: 1px solid #fd9f29;\n}\nhtml.promotioniq-root button.btn.btn-yellow:disabled,\nhtml.promotioniq-root a.btn-yellow:disabled {\n  color: rgba(0, 0, 0, 0.4);\n}\nhtml.promotioniq-root button.btn-transparent,\nhtml.promotioniq-root a.btn-transparent,\nhtml.promotioniq-root button.btn.btn-transparent:active,\nhtml.promotioniq-root button.btn-transparent:focus,\nhtml.promotioniq-root button.btn-transparent:hover,\nhtml.promotioniq-root button.btn-transparent:focus-visible {\n  background-color: transparent;\n  color: #fd9f29;\n  border: 1px solid #fd9f29;\n}\nhtml.promotioniq-root button.btn-small {\n  padding: 0 5px;\n  font-size: 12px;\n  height: 22px;\n}\nhtml.promotioniq-root button.btn-close {\n  background: url(\"../../images/icons/close-icon.png\") no-repeat center\n    center;\n}\nhtml.promotioniq-root button.btn-transparent-gray,\nhtml.promotioniq-root button.btn-transparent-gray:hover {\n  border-color: var(--colorGray);\n  color: var(--colorGray);\n}\nhtml.promotioniq-root .txt-small {\n  font-size: 12px;\n}\nhtml.promotioniq-root .txt-red {\n  color: #ff0000;\n}\nhtml.promotioniq-root .txt-white {\n  color: var(--colorWhite);\n}\nhtml.promotioniq-root .txt-yellow {\n  color: var(--colorYellow);\n}\nhtml.promotioniq-root .txt-orange {\n  color: var(--colorOrange);\n}\nhtml.promotioniq-root .txt-gray {\n  color: var(--colorGray);\n}\nhtml.promotioniq-root .align-end {\n  display: inline-flex;\n  height: 100%;\n  align-items: flex-end;\n}\nhtml.promotioniq-root .bdr-right {\n  border-right: 1px solid var(--colorGray);\n}\nhtml.promotioniq-root .border-dgray {\n  border-color: var(--colorDGray) !important;\n}\n.chkbox-round {\n  width: 25px;\n  height: 25px;\n  padding: 0;\n  position: relative;\n  min-height: auto;\n}\n.chkbox-round.form-check .form-check-input {\n  visibility: hidden;\n}\n.chkbox-round.form-check .form-check-input,\n.chkbox-round.form-check label {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  min-width: 25px;\n  margin: 0;\n  line-height: 25px;\n}\n.chkbox-round.form-check label {\n  border: 1px solid var(--colorYellow);\n  cursor: pointer;\n  text-align: center;\n}\n.chkbox-round.chkbox-orange.form-check label {\n  border-color: var(--colorOrange);\n}\n.chkbox-round.chkbox-dorange.form-check label {\n  border-color: var(--colorDOrange);\n}\n.chkbox-round.form-check .form-check-input:checked + label {\n  background-color: var(--colorYellow);\n  color: #000000;\n  font-weight: bold;\n}\n.chkbox-round.chkbox-orange.form-check .form-check-input:checked + label {\n  background-color: var(--colorOrange);\n}\n.chkbox-round.chkbox-dorange.form-check .form-check-input:checked + label {\n  background-color: var(--colorDOrange);\n}\n\n.dropdown {\n  padding-right: 30px;\n  max-width: 100%;\n}\n.dropdown:after {\n  content: \"\";\n  position: absolute;\n  display: block;\n  width: 10px;\n  height: 10px;\n  border-top: 1px solid #bfbfbf;\n  border-left: 1px solid #bfbfbf;\n  transform: rotate(-135deg);\n  right: 10px;\n  top: 50%;\n  margin-top: -8px;\n}\n.dropdown + .dropdown-list {\n  width: 250px;\n  max-width: 100%;\n  position: absolute;\n  z-index: 1;\n}\n.dropdown-list,\n.sub-dropdown-list {\n  display: none;\n  background-color: #0c1017;\n  list-style: none outside;\n  padding: 10px 20px;\n}\n/* .dropdown-list input[type=\"checkbox\"], .sub-dropdown-list input[type=\"checkbox\"]{margin-right: 10px;} */\n.dropdown + .dropdown-list > li > .sub-dropdown-list {\n  position: absolute;\n  width: 100%;\n  left: calc(100% + 5px);\n  top: 0;\n  height: 300px;\n  overflow-y: auto;\n}\n.dropdown.nested + .dropdown-list {\n  position: relative;\n}\n.dropdown.simple + .dropdown-list {\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.divider {\n  display: flex;\n  align-items: center;\n}\n.divider:before,\n.divider:after {\n  flex: 1;\n  content: \"\";\n  height: 1px;\n  background-color: #212121;\n  margin: 5px;\n}\n\n/* scrollbar - scoped to PromotionIQ */\nhtml.promotioniq-root ::-webkit-scrollbar {\n  width: 5px;\n  height: 4px;\n}\nhtml.promotioniq-root ::-webkit-scrollbar-track {\n  background: #444;\n}\nhtml.promotioniq-root ::-webkit-scrollbar-thumb {\n  background: #777;\n}\nhtml.promotioniq-root ::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n/* common - end */\n\n/* leftnav - start */\n/* Note: LeftNav styles are global and should remain so as LeftNav is shared across the app */\n.leftnav {\n  background-color: #191e27;\n  position: fixed;\n  left: 0;\n  top: 0;\n  width: var(--leftNavWidth);\n  height: 100%;\n  text-align: center;\n  padding: 25px 5px;\n  max-height: 100vh;\n  overflow-y: auto;\n}\n.leftnav .leftnav-logo {\n  margin-bottom: 50px;\n}\n.leftnav ul {\n  list-style: none outside;\n  padding-left: 0;\n}\n.leftnav ul li:not(:last-child) {\n  margin-bottom: 25px;\n}\n.leftnav ul li a {\n  color: inherit;\n  font-size: 11px;\n  line-height: 1;\n}\n.leftnav ul li a:hover img,\n.leftnav ul li a.active img {\n  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)\n    hue-rotate(347deg) brightness(96%) contrast(107%);\n}\n\n/* Header icons hover effect */\nheader .header-right a[title=\"Support\"]:hover img,\nheader .header-right a[title=\"Agora\"]:hover img,\nheader .header-right a[title=\"Atlas\"]:hover img {\n  filter: brightness(0) saturate(100%) invert(60%) sepia(81%) saturate(439%)\n    hue-rotate(347deg) brightness(96%) contrast(107%);\n}\n.leftnav ul li a span {\n  display: block;\n  margin-top: 5px;\n}\n\n.leftnav .show-more {\n  transform: rotate(90deg);\n}\n.leftnav .show-more.show {\n  transform: rotate(-90deg);\n}\n/* collapsed leftnav styles */\nbody.leftnav-collapsed {\n  --leftNavWidth: 50px;\n}\nbody.leftnav-collapsed .leftnav {\n  width: var(--leftNavWidth);\n}\nbody.leftnav-collapsed .leftnav ul li a span {\n  display: none;\n}\n.leftnav .collapse-toggle {\n  position: absolute;\n  left: 0;\n  right: 0;\n  margin: 0 auto;\n  bottom: 70px;\n  width: 36px;\n  height: 36px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  transform: rotate(180deg);\n}\n.leftnav .collapse-toggle img {\n  transition: transform 0.2s ease;\n  transform: rotate(0deg);\n}\nbody.leftnav-collapsed .leftnav .collapse-toggle img {\n  transform: rotate(180deg);\n}\n/* leftnav - end */\n\n/* header - start - scoped to PromotionIQ */\nhtml.promotioniq-root header {\n  padding: 35px;\n  margin-bottom: 20px;\n}\nhtml.promotioniq-root header h1,\nhtml.promotioniq-root header h2 {\n  font-family: \"SegoePro-SemiBold\", sans-serif;\n  font-size: 18px;\n  color: var(--colorYellow);\n}\nhtml.promotioniq-root header h2 {\n  margin-left: 8vw;\n}\nhtml.promotioniq-root header .header-left {\n  display: flex;\n}\nhtml.promotioniq-root header .header-left .company-name:after {\n  content: \"|\";\n  margin: 0 10px;\n  color: var(--colorGray);\n}\nhtml.promotioniq-root header .header-right {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\nhtml.promotioniq-root header .header-right .toggle-page .switch {\n  position: relative;\n  display: inline-block;\n  width: 40px;\n  min-width: auto;\n  height: 20px;\n  margin: 0 10px;\n}\nhtml.promotioniq-root header .header-right .toggle-page .switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\nhtml.promotioniq-root header .header-right .toggle-page .slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #2c2d2f;\n  border: 1px solid var(--colorYellow);\n  -webkit-transition: 0.4s;\n  transition: 0.4s;\n}\nhtml.promotioniq-root header .header-right .toggle-page .slider:before {\n  position: absolute;\n  content: \"\";\n  height: 16px;\n  width: 16px;\n  left: 1px;\n  bottom: 1px;\n  background-color: var(--colorYellow);\n  transition: 0.4s;\n}\nhtml.promotioniq-root header .header-right .toggle-page input:checked + .slider:before {\n  -webkit-transform: translateX(20px);\n  -ms-transform: translateX(20px);\n  transform: translateX(20px);\n}\n\nheader .header-right .notification {\n  margin-left: 35px;\n  position: relative;\n}\nheader .header-right .notification button {\n  position: relative;\n}\nheader .header-right .notification button .count {\n  display: none;\n}\nheader .header-right .notification button.notification-true .count {\n  position: absolute;\n  width: 13px;\n  height: 13px;\n  background-color: red;\n  right: 0;\n  top: 2px;\n  color: var(--colorWhite);\n  font-size: 9px;\n  line-height: 13px;\n  display: block;\n  text-align: center;\n}\nheader .header-right .notification .notification-list {\n  display: none;\n  visibility: hidden;\n  position: absolute;\n  width: 210px;\n  right: -20px;\n  top: 100%;\n  margin-top: 5px;\n  background-color: #191e27;\n  list-style: none outside;\n  margin-bottom: 0;\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--colorGray);\n  box-shadow: 0px 3px 6px #00000029;\n  z-index: 9;\n}\nheader\n  .header-right\n  .notification\n  button.notification-true\n  + .notification-list {\n  visibility: visible;\n}\nheader\n  .header-right\n  .notification\n  button.notification-true\n  + .notification-list.show {\n  display: block;\n}\nheader .header-right .notification .notification-list li {\n  padding: 10px 5px 10px 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  text-align: right;\n}\nheader .header-right .notification .notification-list li a {\n  color: var(--colorYellow);\n  margin-left: auto;\n}\nheader .header-right .notification .notification-list li:not(:last-child) {\n  border-bottom: 1px solid #3d4045;\n}\nheader .header-right .notification .notification-list li:before {\n  content: \"\\2713 \";\n  font-size: 9px;\n  line-height: 15px;\n  color: var(--colorYellow);\n  min-width: 15px;\n  height: 15px;\n  background-color: #3d4045;\n  text-align: center;\n  margin-right: 15px;\n}\n\nheader .header-right .user {\n  margin-left: 20px;\n  padding-left: 20px;\n  border-left: 1px solid var(--colorYellow);\n  position: relative;\n}\nheader .header-right .user button {\n  position: relative;\n}\nheader .header-right .user .user-list {\n  display: none;\n  visibility: hidden;\n  position: absolute;\n  width: 100px;\n  right: -37px;\n  top: 100%;\n  margin-top: 5px;\n  background-color: #191e27;\n  list-style: none outside;\n  margin-bottom: 0;\n  padding: 0 10px;\n  font-size: 12px;\n  color: var(--colorGray);\n  box-shadow: 0px 3px 6px #00000029;\n  z-index: 9;\n}\nheader .header-right .user button.user-true + .user-list {\n  visibility: visible;\n}\nheader .header-right .user button.user-true + .user-list.show {\n  display: block;\n}\nheader .header-right .user .user-list li {\n  padding: 8px 0;\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  text-align: left;\n}\nheader .header-right .user .user-list li a {\n  color: var(--colorGray);\n  margin-left: 0;\n}\nheader .header-right .user .user-list li a:hover {\n  color: var(--colorYellow);\n}\nheader .header-right .user .user-list li span {\n  cursor: pointer;\n  color: var(--colorGray);\n}\nheader .header-right .user .user-list li span:hover {\n  color: var(--colorYellow);\n}\nheader .header-right .user .user-list li:not(:last-child) {\n  border-bottom: 1px solid #3d4045;\n}\n/* header - end */\n\n/*modal styles - scoped to PromotionIQ*/\nhtml.promotioniq-root .modal-content {\n  padding: 3em; /* font-size:.8em; */\n  background: rgba(25, 30, 39, 1);\n  color: #f4f3f2;\n}\nhtml.promotioniq-root .modal-content .form-text {\n  font-size: 10px;\n  color: #6c6f74;\n}\nhtml.promotioniq-root .modal-content .requestdemo {\n  margin-top: -35px;\n}\nhtml.promotioniq-root .form-check label {\n  color: #979a9f;\n  transition: top 2s;\n}\nhtml.promotioniq-root .modal-content .formitem {\n  position: relative;\n}\nhtml.promotioniq-root .modal-content .formitem .form-label {\n  position: absolute;\n  transition-duration: 1s;\n}\nhtml.promotioniq-root .modal-content .formitem .form-label.raisedlabel {\n  top: -25px;\n}\nhtml.promotioniq-root .modal-footer button,\nhtml.promotioniq-root .modal-footer button:active,\nhtml.promotioniq-root .modal-footer button:focus {\n  padding-left: 20px;\n  padding-right: 20px;\n}\nhtml.promotioniq-root .modal-footer button:active:hover,\nhtml.promotioniq-root .modal-footer button:hover {\n  opacity: 0.8;\n}\nhtml.promotioniq-root .modal-header {\n  border: none;\n}\nhtml.promotioniq-root .modal-title {\n  color: #fd9f29;\n}\nhtml.promotioniq-root .modal-footer {\n  border: none;\n  justify-content: flex-start;\n}\nhtml.promotioniq-root .modal-content .message {\n  font-size: 1.1em;\n  color: #fd9f29;\n}\nhtml.promotioniq-root .modal-content select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  background: transparent;\n  background-image: url(\"data:image/svg+xml;utf8,<svg fill='gray' height='24' viewBox='0 0 24 24' width='24' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/><path d='M0 0h24v24H0z' fill='none'/></svg>\");\n  background-repeat: no-repeat;\n  background-position-x: 100%;\n  background-position-y: 5px;\n  border-color: #3d4045;\n  color: #979a9f;\n}\nhtml.promotioniq-root .modal-content button[type=\"cancel\"] {\n  background: transparent;\n  border: 1px solid #fd9f29;\n  color: #fd9f29;\n}\nhtml.promotioniq-root .btn-close {\n  background: url(\"../../images/icons/modalclose.png\") no-repeat;\n  background-size: cover;\n  position: relative;\n  z-index: 1;\n}\n/*modal styles*/\n\n\n\n/* =======================================================================\n   PROMOTIONIQ MODULE STYLES - SCOPED\n   \n   All PromotionIQ styles are scoped under .promotioniq-theme and \n   .promotioniq-root to prevent conflicts with platform-ui styles.\n   ======================================================================= */\n\n/* PromotionIQ Theme Variables - Scoped to prevent conflicts */\n/* Using !important to override Tailwind's default CSS variables from @tailwind base */\nhtml.promotioniq-root,\nhtml.promotioniq-root *,\n.promotioniq-theme,\n.promotioniq-theme * {\n  /* Athena Design Language Colors */\n  /* Core backgrounds - #191E27 */\n  --background: 218 22% 13% !important;\n  /* Foreground text - #F4F3F2 */\n  --foreground: 30 9% 95% !important;\n\n  /* Card surfaces - #212429 */\n  --card: 216 11% 15% !important;\n  --card-foreground: 30 9% 95% !important;\n\n  /* Popover/dropdown - #212429 */\n  --popover: 216 11% 15% !important;\n  --popover-foreground: 30 9% 95% !important;\n\n  /* Primary - Amber/Orange accent #FD9F29 */\n  --primary: 33 98% 58% !important;\n  --primary-foreground: 218 22% 13% !important;\n\n  /* Secondary - Slightly lighter dark */\n  --secondary: 216 11% 18% !important;\n  --secondary-foreground: 30 9% 90% !important;\n\n  /* Muted - Gray #7E7E7E based */\n  --muted: 216 11% 20% !important;\n  --muted-foreground: 0 0% 49% !important;\n\n  /* Accent - Subtle orange highlight */\n  --accent: 33 50% 20% !important;\n  --accent-foreground: 33 98% 58% !important;\n\n  /* Destructive - Warning/error */\n  --destructive: 0 72% 51% !important;\n  --destructive-foreground: 0 0% 100% !important;\n\n  /* Success - Pure Green */\n  --success: 142 70% 45% !important;\n  --success-foreground: 0 0% 100% !important;\n\n  /* Warning */\n  --warning: 45 93% 47% !important;\n  --warning-foreground: 218 22% 13% !important;\n\n  /* Borders and inputs */\n  --border: 216 11% 22% !important;\n  --input: 216 11% 18% !important;\n  --ring: 33 98% 58% !important;\n\n  /* Sharp edges - Athena uses edges not curves */\n  --radius: 0rem !important;\n\n  /* Sidebar */\n  --sidebar-background: 218 22% 11% !important;\n  --sidebar-foreground: 30 9% 90% !important;\n  --sidebar-primary: 33 98% 58% !important;\n  --sidebar-primary-foreground: 218 22% 13% !important;\n  --sidebar-accent: 216 11% 16% !important;\n  --sidebar-accent-foreground: 30 9% 95% !important;\n  --sidebar-border: 216 11% 22% !important;\n  --sidebar-ring: 33 98% 58% !important;\n\n  /* Chart colors */\n  --chart-1: 33 98% 58% !important;\n  --chart-2: 173 80% 40% !important;\n  --chart-3: 280 65% 60% !important;\n  --chart-4: 45 93% 47% !important;\n  --chart-5: 0 72% 51% !important;\n}\n\n/* PromotionIQ Component Styles - Scoped */\n@layer components {\n  /* Scoped styles for PromotionIQ wrapper */\n  .promotioniq-theme {\n    /* Reset conflicting platform-ui styles within PromotionIQ */\n    font-family: 'Inter', system-ui, -apple-system, sans-serif;\n    \n    /* Ensure full height for PromotionIQ layout */\n    min-height: 100vh;\n    background-color: hsl(var(--background));\n    color: hsl(var(--foreground));\n  }\n\n  /* Tailwind Preflight (CSS Reset) - Scoped to PromotionIQ */\n  /* This enables Tailwind utilities to work correctly within PromotionIQ */\n  .promotioniq-theme *,\n  .promotioniq-theme *::before,\n  .promotioniq-theme *::after {\n    box-sizing: border-box;\n    border-width: 0;\n    border-style: solid;\n    border-color: hsl(var(--border));\n  }\n\n  .promotioniq-theme {\n    line-height: 1.5;\n    -webkit-text-size-adjust: 100%;\n    -moz-tab-size: 4;\n    tab-size: 4;\n  }\n\n  .promotioniq-theme hr {\n    height: 0;\n    color: inherit;\n    border-top-width: 1px;\n  }\n\n  .promotioniq-theme abbr:where([title]) {\n    text-decoration: underline dotted;\n  }\n\n  .promotioniq-theme b,\n  .promotioniq-theme strong {\n    font-weight: bolder;\n  }\n\n  .promotioniq-theme code,\n  .promotioniq-theme kbd,\n  .promotioniq-theme samp,\n  .promotioniq-theme pre {\n    font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n    font-size: 1em;\n  }\n\n  .promotioniq-theme small {\n    font-size: 80%;\n  }\n\n  .promotioniq-theme sub,\n  .promotioniq-theme sup {\n    font-size: 75%;\n    line-height: 0;\n    position: relative;\n    vertical-align: baseline;\n  }\n\n  .promotioniq-theme sub {\n    bottom: -0.25em;\n  }\n\n  .promotioniq-theme sup {\n    top: -0.5em;\n  }\n\n  .promotioniq-theme table {\n    text-indent: 0;\n    border-color: inherit;\n    border-collapse: collapse;\n  }\n\n  .promotioniq-theme button,\n  .promotioniq-theme input,\n  .promotioniq-theme optgroup,\n  .promotioniq-theme select,\n  .promotioniq-theme textarea {\n    font-family: inherit;\n    font-feature-settings: inherit;\n    font-variation-settings: inherit;\n    font-size: 100%;\n    font-weight: inherit;\n    line-height: inherit;\n    color: inherit;\n    margin: 0;\n    padding: 0;\n  }\n\n  .promotioniq-theme button,\n  .promotioniq-theme select {\n    text-transform: none;\n  }\n\n  .promotioniq-theme button,\n  .promotioniq-theme [type='button'],\n  .promotioniq-theme [type='reset'],\n  .promotioniq-theme [type='submit'] {\n    -webkit-appearance: button;\n    background-color: transparent;\n    background-image: none;\n  }\n\n  .promotioniq-theme :-moz-focusring {\n    outline: auto;\n  }\n\n  .promotioniq-theme :-moz-ui-invalid {\n    box-shadow: none;\n  }\n\n  .promotioniq-theme progress {\n    vertical-align: baseline;\n  }\n\n  .promotioniq-theme ::-webkit-inner-spin-button,\n  .promotioniq-theme ::-webkit-outer-spin-button {\n    height: auto;\n  }\n\n  .promotioniq-theme [type='search'] {\n    -webkit-appearance: textfield;\n    outline-offset: -2px;\n  }\n\n  .promotioniq-theme ::-webkit-search-decoration {\n    -webkit-appearance: none;\n  }\n\n  .promotioniq-theme ::-webkit-file-upload-button {\n    -webkit-appearance: button;\n    font: inherit;\n  }\n\n  .promotioniq-theme summary {\n    display: list-item;\n  }\n\n  .promotioniq-theme blockquote,\n  .promotioniq-theme dl,\n  .promotioniq-theme dd,\n  .promotioniq-theme figure,\n  .promotioniq-theme h1,\n  .promotioniq-theme h2,\n  .promotioniq-theme h3,\n  .promotioniq-theme h4,\n  .promotioniq-theme h5,\n  .promotioniq-theme h6,\n  .promotioniq-theme hr,\n  .promotioniq-theme p,\n  .promotioniq-theme pre {\n    margin: 0;\n  }\n\n  .promotioniq-theme fieldset {\n    margin: 0;\n    padding: 0;\n  }\n\n  .promotioniq-theme legend {\n    padding: 0;\n  }\n\n  .promotioniq-theme ol,\n  .promotioniq-theme ul,\n  .promotioniq-theme menu {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n\n  .promotioniq-theme dialog {\n    padding: 0;\n  }\n\n  .promotioniq-theme textarea {\n    resize: vertical;\n  }\n\n  .promotioniq-theme input::placeholder,\n  .promotioniq-theme textarea::placeholder {\n    opacity: 1;\n    color: hsl(var(--muted-foreground));\n  }\n\n  .promotioniq-theme button,\n  .promotioniq-theme [role=\"button\"] {\n    cursor: pointer;\n  }\n\n  .promotioniq-theme :disabled {\n    cursor: default;\n  }\n\n  .promotioniq-theme img,\n  .promotioniq-theme svg,\n  .promotioniq-theme video,\n  .promotioniq-theme canvas,\n  .promotioniq-theme audio,\n  .promotioniq-theme iframe,\n  .promotioniq-theme embed,\n  .promotioniq-theme object {\n    display: block;\n    vertical-align: middle;\n  }\n\n  .promotioniq-theme img,\n  .promotioniq-theme video {\n    max-width: 100%;\n    height: auto;\n  }\n\n  .promotioniq-theme [hidden] {\n    display: none;\n  }\n\n  .promotioniq-theme h1,\n  .promotioniq-theme h2,\n  .promotioniq-theme h3,\n  .promotioniq-theme h4,\n  .promotioniq-theme h5,\n  .promotioniq-theme h6 {\n    font-family: 'Inter', system-ui, -apple-system, sans-serif;\n    font-weight: 600;\n    letter-spacing: -0.025em;\n    color: inherit;\n  }\n\n  .promotioniq-theme a {\n    color: inherit;\n    text-decoration: none;\n  }\n\n  .promotioniq-theme button {\n    font-family: inherit;\n  }\n\n  /* Athena data table styling */\n  .promotioniq-theme .athena-table {\n    width: 100%;\n    border-collapse: collapse;\n  }\n  \n  .promotioniq-theme .athena-table thead {\n    border-bottom: 1px solid hsl(var(--primary) / 0.3);\n  }\n  \n  .promotioniq-theme .athena-table th {\n    padding: 0.75rem 1rem;\n    text-align: left;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: hsl(var(--primary));\n  }\n  \n  .promotioniq-theme .athena-table tbody tr {\n    border-bottom: 1px solid hsl(var(--border) / 0.5);\n    transition: background-color 0.15s;\n  }\n  \n  .promotioniq-theme .athena-table tbody tr:hover {\n    background-color: hsl(var(--muted) / 0.3);\n  }\n  \n  .promotioniq-theme .athena-table tbody tr:nth-child(even) {\n    background-color: hsl(var(--card) / 0.5);\n  }\n  \n  .promotioniq-theme .athena-table td {\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    color: hsl(var(--foreground));\n  }\n\n  /* Metric cards */\n  .promotioniq-theme .metric-card {\n    border: 1px solid hsl(var(--border));\n    background-color: hsl(var(--card));\n    padding: 1.5rem;\n    transition: border-color 0.15s;\n  }\n\n  .promotioniq-theme .metric-card:hover {\n    border-color: hsl(var(--primary) / 0.5);\n  }\n\n  .promotioniq-theme .metric-value {\n    font-size: 1.875rem;\n    font-weight: 700;\n    color: hsl(var(--primary));\n  }\n\n  .promotioniq-theme .metric-label {\n    font-size: 0.875rem;\n    color: hsl(var(--muted-foreground));\n  }\n\n  /* Status badges */\n  .promotioniq-theme .status-badge {\n    display: inline-flex;\n    align-items: center;\n    padding: 0.25rem 0.75rem;\n    font-size: 0.75rem;\n    font-weight: 500;\n  }\n\n  .promotioniq-theme .status-low {\n    background-color: hsl(var(--success) / 0.2);\n    color: hsl(var(--success));\n  }\n\n  .promotioniq-theme .status-medium {\n    background-color: hsl(var(--warning) / 0.2);\n    color: hsl(var(--warning));\n  }\n\n  .promotioniq-theme .status-high {\n    background-color: hsl(var(--destructive) / 0.2);\n    color: hsl(var(--destructive));\n  }\n\n  /* Orange outlined button style */\n  .promotioniq-theme .btn-athena {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    border: 2px solid hsl(var(--primary));\n    background-color: transparent;\n    padding: 0.5rem 1.5rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: hsl(var(--primary));\n    transition: all 0.15s;\n  }\n\n  .promotioniq-theme .btn-athena:hover {\n    background-color: hsl(var(--primary));\n    color: hsl(var(--primary-foreground));\n  }\n\n  .promotioniq-theme .btn-athena-filled {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background-color: hsl(var(--primary));\n    padding: 0.5rem 1.5rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: hsl(var(--primary-foreground));\n    transition: all 0.15s;\n  }\n\n  .promotioniq-theme .btn-athena-filled:hover {\n    background-color: hsl(var(--primary) / 0.9);\n  }\n\n  /* Form inputs Athena style */\n  .promotioniq-theme .input-athena {\n    width: 100%;\n    border: 1px solid hsl(var(--border));\n    background-color: hsl(var(--input));\n    padding: 0.5rem 1rem;\n    color: hsl(var(--foreground));\n  }\n\n  .promotioniq-theme .input-athena::placeholder {\n    color: hsl(var(--muted-foreground));\n  }\n\n  .promotioniq-theme .input-athena:focus {\n    border-color: hsl(var(--primary));\n    outline: none;\n    box-shadow: 0 0 0 1px hsl(var(--primary));\n  }\n\n  .promotioniq-theme .label-athena {\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: hsl(var(--primary));\n  }\n\n  /* Navigation tabs */\n  .promotioniq-theme .nav-tab {\n    position: relative;\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    padding: 0.75rem 1rem;\n    font-size: 0.875rem;\n    font-weight: 500;\n    color: hsl(var(--muted-foreground));\n    transition: color 0.15s;\n  }\n\n  .promotioniq-theme .nav-tab:hover {\n    color: hsl(var(--foreground));\n  }\n\n  .promotioniq-theme .nav-tab.active {\n    color: hsl(var(--primary));\n  }\n\n  .promotioniq-theme .nav-tab.active::after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 2px;\n    background-color: hsl(var(--primary));\n  }\n\n  /* Section headers */\n  .promotioniq-theme .section-header {\n    font-size: 1.125rem;\n    font-weight: 600;\n    color: hsl(var(--primary));\n  }\n\n  /* Legend items */\n  .promotioniq-theme .legend-item {\n    display: flex;\n    align-items: center;\n    gap: 0.5rem;\n    font-size: 0.875rem;\n    color: hsl(var(--foreground));\n  }\n\n  .promotioniq-theme .legend-dot {\n    width: 0.75rem;\n    height: 0.75rem;\n  }\n}\n\n/* Custom scrollbar for PromotionIQ - Scoped */\n.promotioniq-theme ::-webkit-scrollbar {\n  width: 8px;\n  height: 8px;\n}\n\n.promotioniq-theme ::-webkit-scrollbar-track {\n  background-color: hsl(var(--background));\n}\n\n.promotioniq-theme ::-webkit-scrollbar-thumb {\n  background-color: hsl(var(--muted-foreground) / 0.3);\n}\n\n.promotioniq-theme ::-webkit-scrollbar-thumb:hover {\n  background-color: hsl(var(--muted-foreground) / 0.5);\n}\n\n/* Hide platform-ui elements when PromotionIQ is active */\n/* Note: Only hide elements OUTSIDE .promotioniq-theme, not the PromotionIQ header */\n/* LeftNav should remain visible */\nhtml.promotioniq-root .main-wrapper,\nhtml.promotioniq-root > body > header {\n  display: none;\n}\n\n/* Ensure PromotionIQ header is visible */\n.promotioniq-theme header {\n  display: block !important;\n}\n\n/* Set correct body background when PromotionIQ is active */\n/* PromotionIQ uses #191E27 (hsl 218 22% 13%) not #0c1017 */\nhtml.promotioniq-root,\nhtml.promotioniq-root body {\n  background-color: hsl(218 22% 13%) !important;\n  margin: 0;\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
